let agdtoken;
var pdata = {};
var pdataNewapi = {};
var vrmsrchsku = [];
var mk;
var md;
var mdv;
var eng;
var btyp;
var der;
var adgurl;
var adgurlNew;
var autogVRM;
var trt;
var fuel;
mk = "";
md = "";
mdv = 0;
eng = 0;
btyp = 0;
der = 0;
fuel = 0;
trt = 0;
agdtoken = "";
adgurl = "https://api.autoguruservices.com/";
adgurlNew = "https://appdemo.tradevehicleparts.co.uk/vrmdata/data.php?";
var ADGBodyCategory = [
  { id: 1, brand: "Diffuser" },
  { id: 2, brand: "Door Mirror Complete" },
  { id: 3, brand: "Door Mirror Cover" },
  { id: 4, brand: "Bonnet" },
  { id: 5, brand: "Bumper" },
  { id: 6, brand: "Bumper Bracket" },
  { id: 7, brand: "Bumper Reinforcer" },
  { id: 8, brand: "Front Panel" },
  { id: 9, brand: "Grille" },
  { id: 10, brand: "Grille Trim" },
  { id: 11, brand: "Headlight Mounting" },
  { id: 12, brand: "Towing Eye Cover" },
  { id: 13, brand: "Wheel Arch Liner" },
  { id: 14, brand: "Wing" },
  { id: 15, brand: "Fog Light" },
  { id: 16, brand: "Headlight" },
  { id: 17, brand: "Heater Motor" },
  { id: 18, brand: "Door Mirror Indicator" },
  { id: 19, brand: "Reflectors" },
  { id: 20, brand: "Under Tray" },
  { id: 21, brand: "Air Deflector" },
  { id: 22, brand: "Bonnet Trim" },
  { id: 23, brand: "Bumper Spoiler" },
  { id: 24, brand: "Door Handle" },
  { id: 25, brand: "Parcel Shelf" },
  { id: 26, brand: "Tailgate Spoiler" },
  { id: 27, brand: "Washer Bottle Tank" },
  { id: 28, brand: "Rear Light" },
  { id: 29, brand: "Cross Tube" },
  { id: 30, brand: "Battery Tray Cover" },
  { id: 31, brand: "Air Filter Housing" },
  { id: 32, brand: "ACrossmember" },
  { id: 33, brand: "Door Trim" },
  { id: 34, brand: "ECU Casing" },
  { id: 35, brand: "ECU Cover" },
  { id: 36, brand: "Fuel Flap" },
  { id: 37, brand: "Tailgate Spoiler" },
  { id: 38, brand: "Washer Jet" },
  { id: 39, brand: "Radiator" },
  { id: 40, brand: "Roof Tent" },
  { id: 41, brand: "Boot Trim" },
  { id: 42, brand: "Bumper Kit" },
  { id: 43, brand: "Slam Panel" },
  { id: 44, brand: "Bumper Reinforcer" },
  { id: 45, brand: "Boot Trim" },
   { id: 46, brand: "NOx Sensor" },
{ id: 47, brand: "Handbrake Switch" },
{ id: 48, brand: "Running Board Motor" },
{ id: 49, brand: "Air Suspension Kit" },
{ id: 50, brand: "Air Suspension Compressor" },
{ id: 51, brand: "Shock Absorber" },
{ id: 52, brand: "Air Spring" },
{ id: 53, brand: "Inlet Manifold" },
{ id: 54, brand: "Transfer Case" },
{ id: 55, brand: "Suspension Arm" },
{ id: 56, brand: "EGR Valve" },
{ id: 57, brand: "EGR Cooler" },
{ id: 58, brand: "PAS Pump" },
{ id: 59, brand: "Rocker Cover" }, 
{ id: 60, brand: "Oil Filter Housing" },
{ id: 61, brand: "Throttle Body" },
{ id: 62, brand: "Water Pump" },
{ id: 63, brand: "Door Lock" },
  {id:64, brand:"Boot/Tailgate Strut"}, 
  {id:65, brand:"Engine"}, 
  {id:66, brand:"Air Suspension Compressor"},
];
function ip_tracking_now(i) {
  $.getJSON("https://appdemo.tradevehicleparts.co.uk/user_search_tracking_ip/get_ip.php", function (p) {
    createCookie("user_ip_tracking", p.ip, 24);

    $.post(
      "https://appdemo.tradevehicleparts.co.uk/user_search_tracking_ip/indexuser.php",
      {
        uip: p.ip,
        valwhe: i
      },
      function (resp, status) {
        createCookie("ip_tracking", resp, 24);
      }
    );
  });
}

// Consent gate helper — returns true only if Pandectes has granted performance
// consent (reads _pandectes_gdpr cookie via tvp_hasConsent helper).
// VRM API accepts user_ip_tracking="0" as fallback, so all VRM features
// remain functional when performance consent is declined.
function tvp_analyticsGranted() {
  return typeof tvp_hasConsent === 'function' && tvp_hasConsent('performance');
}

function tvp_ip_tracking_if_consented(val) {
  if (tvp_analyticsGranted()) {
    ip_tracking_now(val);
  }
}
// Define the showPopup function
function showPopup(productType) {
  let popupText = "";
  switch (productType) {
    case "MIRROR":
      popupText =
        "There are different types of mirrors available for your vehicle...";
      break;
    case "BUMPER ONE PIECE":
    case "BUMPER CENTRE":
    case "BUMPER END":
    case "BUMPER KIT":
    case "TUNING FRONT BUMPER KIT":
    case "TUNING REAR BUMPER KIT":
      popupText =
        "There are different types of bumpers available for your vehicle...";
      break;
    case "HEADLIGHT":
      popupText =
        "There are different types of headlights available for your vehicle...";
      break;
    case "WING":
      popupText =
        "There are different types of wings available for your vehicle...";
      break;
    default:
      popupText = "Bothing";
      break;
  }
  $("#popup_producttype").html(popupText);
}
$("#okButton").on("click", function () {
  $("#popup_producttype").fadeOut();
});
jQuery(document).ready(function () {
  // IP fetch gated behind analytics consent — skipped when user declines
  if (tvp_analyticsGranted()) {
    var user_ip_tracking = (getCookie("user_ip_tracking") || "0");
    if (user_ip_tracking !== null && user_ip_tracking == 0 && user_ip_tracking != "") {
      fetch("https://appdemo.tradevehicleparts.co.uk/user_search_tracking_ip/get_ip.php", { mode: "cors" })
        .then(function(resp) { return resp.json(); })
        .then(function(ip) { createCookie("user_ip_tracking", ip.ip, 24); })
        .catch(function(err) { console.warn("IP fetch failed", err); });
    }
  }
  if ($("#vcomponent").length) {
    $("#vcomponent").html("");
    if (
      localStorage.getItem("bodysubcatsrc") &&
      localStorage.getItem("bodysubcatsrc") != "" &&
      localStorage.getItem("bodysubcatsrc") != null &&
      localStorage.getItem("bodysubcatsrc") !== null &&
      localStorage.getItem("bodysubcatsrc") != undefined
    ) {
      $("#vcomponent").html(localStorage.getItem("bodysubcatsrc"));
    }
  }
  $("#button").click(function () {
    var vihclenumber;
    let vihclenumber1 = $("#vihclenumber").val();
    let vihclenumber2 = vihclenumber1.replace(/\s/g, "");
    let vihclenumber3 = vihclenumber2.replace(/\s+/g, "");
    vihclenumber = vihclenumber3.trim();

    if (
      vihclenumber == "" ||
      vihclenumber == "YOUR REG" ||
      vihclenumber == "YOUR%20REG" ||
      vihclenumber == "YOURREG"
    ) {
      alert("Please enter vehicle number");
      return false;
    }
    tvp_ip_tracking_if_consented(3);
    ip_tracking = getCookie("ip_tracking");

    if (ip_tracking !== null && ip_tracking == 0 && ip_tracking != "") {
      alert(
        "Sorry you have reached your VRM lookup limit for today. If you require a bigger daily limit, please let us know. You can either call us on 0116 319 6543, send us an email at sales@tradevehicleparts.co.uk, or get in touch on the live chat. Thanks!"
      );
      return false;
    }
    $("#button").hide();
    $("#ldngimg").show();
    var is_found = 0;
    var skulist = "";
    $.ajax({
      url:
        adgurlNew +
        "api_id=72841&vrm=" +
        $("#vihclenumber").val() +
        "&ip=" +
        (getCookie("user_ip_tracking") || "0") +
        "&function_id=buttonclick",
      type: "GET",
      success: function (result3) {
        var parsedObj = (typeof result3 === "string") ? JSON.parse(result3) : result3;
        var vlen = parsedObj.categories.length;
        let skucnt;
        skucnt = 0;
        for (var v = 0; v < vlen; ++v) {
          var ilen = parsedObj.categories[v].subcategories.length;
          for (var i = 0; i < ilen; ++i) {
            var jlen =
              parsedObj.categories[v].subcategories[i].components.length;
            for (var j = 0; j < jlen; ++j) {
              var klen =
                parsedObj.categories[v].subcategories[i].components[j].parts
                  .length;
              for (var k = 0; k < klen; ++k) {
                skucnt++;
                if (skucnt < 50) {
                  if (is_found == 0) {
                    skulist =
                      parsedObj.categories[v].subcategories[i].components[j]
                        .parts[k].number;
                  } else {
                    skulist =
                      skulist +
                      "+OR+" +
                      parsedObj.categories[v].subcategories[i].components[j]
                        .parts[k].number;
                  }
                  vrmsrchsku.push(
                    parsedObj.categories[v].subcategories[i].components[j]
                      .parts[k].number
                  );
                }
                is_found = 1;
              }
            }
          }
        }
        /* adding new category start */
for (var v = 0; v < vlen; ++v) {
	if(parsedObj.categories[v].subcategories.length==0 && parsedObj.categories[v].components.length > 0){
      
            for (var k = 0; k < parsedObj.categories[v].components.length; ++k) {
                for (var p = 0; p < parsedObj.categories[v].components[k].parts.length; ++p) {
				skucnt++;
                 
               if (skucnt < 50) {
                  if (is_found == 0) {
                    skulist =
                      parsedObj.categories[v].components[k]
                        .parts[p].number;
                  } else {
                    skulist =
                      skulist +
                      "+OR+" +
                      parsedObj.categories[v].components[k]
                        .parts[p].number;
                  }
                  vrmsrchsku.push(
                    parsedObj.categories[v].components[k]
                      .parts[p].number
                  );
                }
                is_found = 1;
                }
                
			}
        }
    }
              /* adding new category end */	
        createCookie("vrmsrchsku", JSON.stringify(vrmsrchsku), 1 / 8);
        createCookie("ckksrcmake", "", -1);
        createCookie("ckksrcmodel", "", -1);
        createCookie("ckksrcmodelver", "", -1);
        createCookie("ckksrcmodeleng", "", -1);
        createCookie("ckksrcmodelbodystyles", "", -1);
        createCookie("ckksrcmodelderivatives", "", -1);
        createCookie("ckksrfueltype", "", -1);
        createCookie("ckksrtransmissiontype", "", -1);
        createCookie("vinno", "", -1);
        createCookie("regno", "", -1);
        createCookie("enginecode", "", -1);
        createCookie("doors", "", -1);
        localStorage.ckksrcmake = "";
        localStorage.ckksrcmodel = "";
        localStorage.ckksrcmodelver = "";
        localStorage.ckksrcmodeleng = "";
        localStorage.ckksrcmodelbodystyles = "";
        localStorage.ckksrcmodelderivatives = "";
        localStorage.ckksrfueltype = "";
        localStorage.ckksrtransmissiontype = "";
        localStorage.setItem("manualsrchurl", "");
        localStorage.setItem("vrmsrchurl", "");
        localStorage.manualsrchurl = "";
        localStorage.vrmsrchurl = "";
        localStorage.setItem("bodysubcat", "");
        localStorage.bodysubcat = "";
        localStorage.setItem("bodysubcatsrc", "");
        localStorage.bodysubcatsrc = "";
        localStorage.setItem("vinno", "");
        localStorage.vinno = "";
        localStorage.setItem("regno", "");
        localStorage.regno = "";
        localStorage.setItem("enginecode", "");
        localStorage.enginecode = "";
        localStorage.setItem("doors", "");
        localStorage.doors = "";
        localStorage.setItem("vihclenumberfit", "");
        localStorage.vihclenumberfit = "";
        createCookie("vihclenumberfit", "", -1);
        var ebayid;
        ebayid = 0;
        $.ajax({
          //url: adgurl + "V2/vehicle/" + $("#vihclenumber").val(),
          url:
            adgurlNew +
            "api_id=72846&vihclenumber=" +
            $("#vihclenumber").val() +
            "&ip=" +
            (getCookie("user_ip_tracking") || "0") +
            "&function_id=button213",
          type: "GET",
          error: function (response) {
            $("#ldngimgsrc").hide();
            $(".btngolodding").hide();
            $("#button").show();
            alert(
              "No vehicle found for this reg number, please check the number and try again."
            );
            return false;
          },
          success: function (result12) {
            result1 = result12;
            var d = new Date(
              result1.dvladata.registrationdate.firstregistration
            );
            var n = d.getFullYear();
            var date = n;
            var qstr = "";
            var qstr1 = "";
            var qstr2 = "";
            var qstr3 = "";
            var qstr4 = "";
            var qstr5 = "";
            if (Boolean(result1.enhanceddata.gcodedata.manufacturer)) {
              createCookie(
                "ckksvManufacturer",
                result1.enhanceddata.gcodedata.manufacturer,
                1 / 12
              );
            }
            if (Boolean(result1.enhanceddata.gcodedata.model)) {
              createCookie(
                "ckksvModel",
                result1.enhanceddata.gcodedata.model,
                1 / 12
              );
            }
            if (Boolean(date)) {
              createCookie("ckksvYear", date, 1 / 12);
            }
            if (Boolean(result1.enhanceddata.gcodedata.engine.size.litre)) {
              createCookie(
                "ckksvEngine",
                result1.enhanceddata.gcodedata.engine.size.litre,
                1 / 12
              );
            }
            if (Boolean(result1.enhanceddata.gcodedata.fueltype)) {
              createCookie(
                "ckksvFuel",
                result1.enhanceddata.gcodedata.fueltype,
                1 / 12
              );
            }
            if (Boolean(result1.enhanceddata.gcodedata.bodystyle)) {
              createCookie(
                "ckksvBodystyle",
                result1.enhanceddata.gcodedata.bodystyle,
                1 / 12
              );
            }
            if (Boolean(result1.identifiers.vin)) {
              createCookie("vinno", result1.identifiers.vin, 1 / 12);
            }
            if (Boolean(result1.identifiers.vrm)) {
              createCookie("regno", result1.identifiers.vrm, 1 / 12);
            }
            if (Boolean(result1.enhanceddata.gcodedata.engine.code)) {
              createCookie(
                "enginecode",
                result1.enhanceddata.gcodedata.engine.code,
                1 / 12
              );
            }
            if (Boolean(result1.enhanceddata.gcodedata.doorcount)) {
              createCookie(
                "doors",
                result1.enhanceddata.gcodedata.doorcount,
                1 / 12
              );
            }
            if (Boolean(result1.dvladata.registrationdate.firstregistration)) {
              var d = new Date(
                result1.dvladata.registrationdate.firstregistration
              );
              var dd = d.getDate();
              var mm = d.getMonth() + 1;

              var yyyy = d.getFullYear();
              if (dd < 10) {
                dd = "0" + dd;
              }
              if (mm < 10) {
                mm = "0" + mm;
              }
              var frregtoday = dd + "/" + mm + "/" + yyyy;
              createCookie("ckksvfrreg", frregtoday, 1 / 12);
            }
            if (Boolean(result1.enhanceddata.gcodedata.derivative)) {
              createCookie(
                "ckksvderivative",
                result1.enhanceddata.gcodedata.derivative,
                1 / 12
              );
            }
            if (Boolean(result1.identifiers.thirdparty.ebay.ebayid)) {
              ebayid = result1.identifiers.thirdparty.ebay.ebayid;
            }
            /* TVP collection-page hook: if this is a whitelisted body/mech/brand collection,
               let the page-defined redirect take over (routes to /pages/products with the
               correct node/cat/subcat/bodyskus instead of the generic finder). */
            if (typeof window.tvpCollectionRedirect === 'function') {
              localStorage.setItem(
                "vrmsrchurl",
                siteurls +
                  "/pages/product-category?id=" +
                  ebayid +
                  "&autog=" +
                  $("#vihclenumber").val()
              );
              createCookie("ckkautog", $("#vihclenumber").val(), 1 / 12);
              if (window.tvpCollectionRedirect(ebayid, $("#vihclenumber").val())) return;
            }
            if (is_found == 1) {
              localStorage.setItem(
                "vrmsrchurl",
                siteurls +
                  "/pages/product-category?id=" +
                  ebayid +
                  "&autog=" +
                  $("#vihclenumber").val()
              );
              window.location= siteurls +
                  "/pages/product-category?id=" +
                  ebayid +
                  "&autog=" +
                  $("#vihclenumber").val();
            } else {
              localStorage.setItem(
                "vrmsrchurl",
                siteurls +
                  "/pages/product-category?id=" +
                  ebayid +
                  "&autog=" +
                  $("#vihclenumber").val()
              );             
              window.location=siteurls +
                  "/pages/product-category?id=" +
                  ebayid +
                  "&autog=" +
                  $("#vihclenumber").val();
            }
          },
          statusCode: {
            404: function () {
              if (is_found == 1) {
                window.location=siteurls +
                    "/pages/product-category?id=" +
                    ebayid +
                    "&autog=" +
                    $("#vihclenumber").val();
              } else {
                window.location=siteurls +
                    "/pages/product-category?id=" +
                    ebayid +
                    "&autog=" +
                    $("#vihclenumber").val();
              }
            },
            400: function () {              
              return false;
              if (is_found == 1) {
                window.location= siteurls +
                    "/pages/product-category?id=" +
                    ebayid +
                    "&autog=" +
                    $("#vihclenumber").val();
              } else {
                window.location=siteurls +
                    "/pages/product-category?id=" +
                    ebayid +
                    "&autog=" +
                    $("#vihclenumber").val();
              }
            },
            403: function () {
              if (is_found == 1) {
                window.location=siteurls +
                    "/pages/product-category?id=" +
                    ebayid +
                    "&autog=" +
                    $("#vihclenumber").val();
              } else {
                window.location=siteurls +
                    "/pages/product-category?id=" +
                    ebayid +
                    "&autog=" +
                    $("#vihclenumber").val();
              }
            },
          },
        });
      },
      statusCode: {
        404: function () {
          window.location=siteurls +
              "/pages/product-category?id=" +
              ebayid +
              "&autog=" +
              $("#vihclenumber").val();
        },
        400: function () {
          window.location=siteurls +
              "/pages/product-category?id=" +
              ebayid +
              "&autog=" +
              $("#vihclenumber").val();
        },
        403: function () {
          window.location=siteurls +
              "/pages/product-category?id=" +
              ebayid +
              "&autog=" +
              $("#vihclenumber").val();
        },
      },
    });
  });
  $("#buttondtl").click(function () {
    if ($("#vihclenumberdtl").val() == "") {
      alert("Please enter VRM");
    } else {
      $.ajax({
        url:
          adgurlNew +
          "api_id=72878&vrm=" +
          $("#vihclenumberdtl").val() +
          "&ip=" +
          (getCookie("user_ip_tracking") || "0") +
          "&pageulr=" +
          window.location.href,
        type: "GET",
        contentType: "application/json",
        ataType: "json",
        success: function (result2) {},
        statusCode: {
          404: function () {
            $("#vsrcresult").html("No record found");
          },
          400: function () {
            $("#vsrcresult").html("No record found");
          },
          403: function () {
            $("#vsrcresult").html("No record found");
          },
        },
      });
    }
  });
});
/*  vehicle reg no end */
function getQueryStringParameters() {
  var parameters = {},
    hash;
  var q = document.URL.split("?")[1];
  if (q != undefined) {
    q = q.split("&");
    for (var i = 0; i < q.length; i++) {
      hash = q[i].split("=");
      parameters[hash[0]] = hash[1];
    }
  }
  return parameters;
}
function isEmpty(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) return false;
  }
  return true;
}
/* vehicle reg no catalog start */
(function ($) {
  get_vrm_details();
})(jQuery);
function get_vrm_details() {
  var autogVRM = 0;
  var parameters = getQueryStringParameters();
  if (isEmpty(parameters) == false) {
    $.each(parameters, function (key, value) {
      if (key == "autog") {
        $("#vmodel").prop("disabled", false);
        $("#vmodelver").prop("disabled", false);
        $("#vmodeleng").prop("disabled", false);
        $("#vmodelbodystyles").prop("disabled", false);
        $("#vmodelderivatives").prop("disabled", false);
        $("#vfueltype").prop("disabled", false);
        $("#vtransmissiontype").prop("disabled", false);
        autogVRM = value;
        $("#vihclenumberfit").val(autogVRM);
        sessionStorage.setItem("tvp_reg", autogVRM);
        $("#checkfitment").hide();
        $("#checkfitsuc").hide();
        $(".checkfitsuc-alt").hide();
        $("#checkfitfail").hide();
        $(".checkfitfail-alt").hide();
        if ($(".autovrmdata1").length) {
          const mq1 = window.matchMedia("(min-width: 749px)");
          if ($("#100001").length) {
            $("#100001").html("");
            if (
              localStorage.getItem("bodysubcat") &&
              localStorage.getItem("bodysubcat") != "" &&
              localStorage.getItem("bodysubcat") != null &&
              localStorage.getItem("bodysubcat") !== null &&
              localStorage.getItem("bodysubcat") != undefined
            ) {
              $("#100001").html(localStorage.getItem("bodysubcat"));
            }
          }
          if (mq1.matches) {
            $(".autovrmdata").show();

            if ($("#vcomponent").length) {
              $("#vcomponent").html("");
              if (
                localStorage.getItem("bodysubcatsrc") &&
                localStorage.getItem("bodysubcatsrc") != "" &&
                localStorage.getItem("bodysubcatsrc") != null &&
                localStorage.getItem("bodysubcatsrc") !== null &&
                localStorage.getItem("bodysubcatsrc") != undefined
              ) {
                $("#vcomponent").html(localStorage.getItem("bodysubcatsrc"));
              }
            }
            $(".autovrmdata1").hide();
          } else {
            $(".autovrmdata1").show();
            if ($("#vcomponent").length) {
              $("#vcomponent").html("");
              if (
                localStorage.getItem("bodysubcatsrc") &&
                localStorage.getItem("bodysubcatsrc") != "" &&
                localStorage.getItem("bodysubcatsrc") != null &&
                localStorage.getItem("bodysubcatsrc") !== null &&
                localStorage.getItem("bodysubcatsrc") != undefined
              ) {
                $("#vcomponent").html(localStorage.getItem("bodysubcatsrc"));
              }
            }
            $(".autovrmdata").hide();
          }
        } else {
          if ($("#100001").length) {
            $("#100001").html("");
            if (
              localStorage.getItem("bodysubcat") &&
              localStorage.getItem("bodysubcat") != "" &&
              localStorage.getItem("bodysubcat") != null &&
              localStorage.getItem("bodysubcat") !== null &&
              localStorage.getItem("bodysubcat") != undefined
            ) {
              $("#100001").html(localStorage.getItem("bodysubcat"));
            }
          }
          $(".autovrmdata").show();
        }
        $("#vsrcresult").css("float", "left");
        $(".sb-car-shopify").hide();
        let onlyCharacters = value.replaceAll(" ", "");
        let onlyCharacter1s = onlyCharacters.replaceAll("%20", "");
        var api_url1 =
          adgurlNew +
          "api_id=72846&vihclenumber=" +
          onlyCharacter1s +
          "&ip=" +
          (getCookie("user_ip_tracking") || "0") +
          "&function_id=get_vrm_details";
        // var api_url2 = adgurl + "V3/country/GB/vehicle/" + onlyCharacter1s + "/vehicleimage?doReturnPlaceholderImage=true";
        var api_url2 =
          adgurlNew +
          "api_id=72876&vrm=" +
          onlyCharacter1s +
          "&ip=" +
          (getCookie("user_ip_tracking") || "0") +
          "&function_id=411";
        //var api_url3 = adgurl + "v1/vrm/"+onlyCharacter1s+"/partnumbers";
        var api_url3 =
          adgurlNew +
          "api_id=72841&vrm=" +
          onlyCharacter1s +
          "&ip=" +
          (getCookie("user_ip_tracking") || "0") +
          "&function_id=get_vrm_details";
        var ckksvImg;
        ckksvImg = localStorage.getItem("ckksvImgn");
        if (
          ckksvImg !== null &&
          ckksvImg != undefined &&
          ckksvImg != "undefined" &&
          ckksvImg != ""
        ) {
          $("#svImg").html(
            '<img class="imgzoom" src="data:image/png;base64,' +
              /*JSON.parse*/ ckksvImg +
              '" width="100px" />'
          );
          if ($("#svImg1").length) {
            $("#svImg1").html(
              '<img class="imgzoom" src="data:image/png;base64,' +
                /*JSON.parse*/ ckksvImg +
                '" width="100px" />'
            );
          }
        } else {
          $.ajax({
            url: api_url2,
            type: "GET",
            error: function (response) {
              $("#svImg").html("No image");
              if ($("#svImg1").length) {
                $("#svImg1").html("No image");
              }
            },
            success: function (result2) {
              var result2 = (typeof result2 === "string") ? JSON.parse(result2) : result2;
              if (!Boolean(result2.isplaceholderimage)) {
                if (result2.images) {
                  $("#svImg").html(
                    '<img class="imgzoom" src="data:image/png;base64,' +
                      result2.images +
                      '" width="100px" />'
                  );
                  localStorage.setItem("ckksvImgn", result2.images);
                  if ($("#svImg1").length) {
                    $("#svImg1").html(
                      '<img class="imgzoom" src="data:image/png;base64,' +
                        result2.images +
                        '" width="100px" />'
                    );
                  }
                } else {
                  $("#svImg").html("No image");
                  if ($("#svImg1").length) {
                    $("#svImg1").html("No image");
                  }
                  localStorage.setItem("ckksvImgn", "");
                  createCookie("ckksvImgn", "", 1 / 12);
                }
              } else {
                $("#svImg").html("No image");
                if ($("#svImg1").length) {
                  $("#svImg1").html("No image");
                }
                createCookie("ckksvImgn", "", 1 / 12);
                localStorage.setItem("ckksvImgn", "");
              }
            },
            statusCode: {
              404: function () {
                $("#vsrcresult").html("No record found");
              },
              400: function () {
                $("#vsrcresult").html("No record found");
              },
              403: function () {
                $("#vsrcresult").html("No record found");
              },
            },
          });
        }
        var ckksvManufacturer;
        var ckksvModel;
        var ckksvYear;
        var ckksvEngine;
        var ckksvFuel;
        var ckksvBodystyle;
        var ckksvfrreg;
        var ckksvderivative;
        var ckkvfueltype;
        var ckkvtransmissiontype;
        var vinno;
        var regno;
        var enginecode;
        var doors;
        ckksvManufacturer = "";
        ckksvModel = "";
        ckksvYear = "";
        ckksvEngine = "";
        ckksvFuel = "";
        ckksvBodystyle = "";
        ckksvfrreg = "";
        ckksvderivative = "";
        ckkvfueltype = "";
        ckkvtransmissiontype = "";
        vinno = "";
        regno = "";
        enginecode = "";
        doors = "";
        if (getCookie("ckkautog") == value) {
          ckksvManufacturer = getCookie("ckksvManufacturer");
          ckksvModel = getCookie("ckksvModel");
          ckksvYear = getCookie("ckksvYear");
          ckksvEngine = getCookie("ckksvEngine");
          ckksvFuel = getCookie("ckksvFuel");
          ckksvBodystyle = getCookie("ckksvBodystyle");
          ckksvfrreg = getCookie("ckksvfrreg");
          ckksvderivative = getCookie("ckksvderivative");
          ckkvfueltype = getCookie("ckkvfueltype");
          ckkvtransmissiontype = getCookie("ckkvtransmissiontype");
          vinno = getCookie("vinno");
          regno = getCookie("regno");
          enginecode = getCookie("enginecode");
          doors = getCookie("doors");
          $("#vinnolabel").show();
          $("#regnolabel").show();
          $("#enginecodelabel").show();
          $("#doorslabel").show();
        }
        if (
          ckksvManufacturer != "" &&
          ckksvManufacturer !== null &&
          ckksvModel !== null &&
          ckksvModel != "" &&
          ckksvYear !== null &&
          ckksvEngine !== null &&
          ckksvFuel !== null &&
          ckksvBodystyle !== null &&
          ckksvfrreg !== null &&
          ckksvderivative !== null
        ) {
          $("#svManufacturer").html("");
          $("#svManufacturer").html(ckksvManufacturer);
          $("#svModel").html(ckksvModel);
          $("#svYear").html(ckksvYear);
          $("#svEngine").html(ckksvEngine);
          $("#svFuel").html(ckksvFuel);
          $("#svBodystyle").html(ckksvBodystyle);
          $("#svfrReg").html(ckksvfrreg);
          $("#svderivative").html(ckksvderivative);
          $("#vfueltype").html(ckkvfueltype);
          $("#vtransmissiontype").html(ckkvtransmissiontype);
          $("#adgmmdyear").html("");
          $("#adgmmdyear").html(
            ckksvManufacturer +
              " " +
              ckksvModel +
              " " +
              ckksvderivative +
              " " +
              ckksvYear
          );
          $("#vinno").html(vinno);
          $("#regno").html(regno);
          $("#enginecode").html(enginecode);
          $("#doors").html(doors);
          $("#vinno").show();
          $("#regno").show();
          $("#enginecode").show();
          $("#doors").show();
          $("#vinnolabel").show();
          $("#regnolabel").show();
          $("#enginecodelabel").show();
          $("#doorslabel").show();
          $("#showBtnchngvh").show();
          if ($("#svManufacturer1").length) {
            $("#svManufacturer1").html("");
            $("#svManufacturer1").html(ckksvManufacturer);
            $("#showBtnchngvh").show();
          }
          if ($("#svModel1").length) {
            $("#svModel1").html(ckksvModel);
          }
          if ($("#svYear1").length) {
            $("#svYear1").html(ckksvYear);
          }
          if ($("#svEngine1").length) {
            $("#svEngine1").html(ckksvEngine);
          }
          if ($("#svFuel1").length) {
            $("#svFuel1").html(ckksvFuel);
          }
          if ($("#svBodystyle1").length) {
            $("#svBodystyle1").html(ckksvBodystyle);
          }
          if ($("#svfrReg1").length) {
            $("#svfrReg1").html(ckksvfrreg);
          }
          if ($("#svderivative1").length) {
            $("#svderivative1").html(ckksvderivative);
          }
          if ($("#vfueltype1").length) {
            $("#vfueltype1").html(ckkvfueltype);
          }
          if ($("#vtransmissiontype1").length) {
            $("#vtransmissiontype1").html(ckkvtransmissiontype);
          }
          if ($("#vinno1").length) {
            $("#vinno1").html(vinno);
            $("#vinnolabel1").show();
          }
          if ($("#regno1").length) {
            $("#regno1").html(regno);
            $("#regnolabel1").show();
          }
          if ($("#enginecode1").length) {
            $("#enginecode1").html(enginecode);
            $("#enginecodelabel1").show();
          }
          if ($("#doors1").length) {
            $("#doors1").html(doors);
            $("#doorslabel1").show();
          }
        } else {
          createCookie("ckkautog", value, 1 / 12);
          ckksvManufacturer = getCookie("ckksvManufacturer");
          ckksvModel = getCookie("ckksvModel");
          ckksvYear = getCookie("ckksvYear");
          ckksvEngine = getCookie("ckksvEngine");
          ckksvFuel = getCookie("ckksvFuel");
          ckksvBodystyle = getCookie("ckksvBodystyle");
          ckksvfrreg = getCookie("ckksvfrreg");
          ckksvderivative = getCookie("ckksvderivative");
          ckkvfueltype = getCookie("ckkvfueltype");
          ckkvtransmissiontype = getCookie("ckkvtransmissiontype");
          vinno = getCookie("vinno");
          regno = getCookie("regno");
          enginecode = getCookie("enginecode");
          doors = getCookie("doors");
          $("#vinnolabel").show();
          $("#regnolabel").show();
          $("#enginecodelabel").show();
          $("#doorslabel").show();
          if (
            ckksvManufacturer != "" &&
            ckksvManufacturer !== null &&
            ckksvModel !== null &&
            ckksvModel != "" &&
            ckksvYear !== null &&
            ckksvEngine !== null &&
            ckksvFuel !== null &&
            ckksvBodystyle !== null &&
            ckksvfrreg !== null &&
            ckksvderivative !== null
          ) {
            $("#svManufacturer").html("");
            $("#svManufacturer").html(ckksvManufacturer);
            $("#showBtnchngvh").show();
            if ($("#svManufacturer1").length) {
              $("#svManufacturer1").html(ckksvManufacturer);
              $("#showBtnchngvh").show();
            }
            $("#svModel").html(ckksvModel);
            createCookie("ckksvModel", ckksvModel, 1 / 12);
            if ($("#svModel1").length) {              
              $("#svModel1").html(ckksvModel);
            }
            $("#svYear").html(ckksvYear);
            if ($("#svYear1").length) {
              $("#svYear1").html(ckksvYear);
            }
            $("#svEngine").html(ckksvEngine);
            if ($("#svEngine1").length) {
              $("#svEngine1").html(ckksvEngine);
            }
            $("#svFuel").html(ckksvFuel);
            if ($("#svFuel1").length) {
              $("#svFuel1").html(ckksvFuel);
            }
            $("#svBodystyle").html(ckksvBodystyle);
            if ($("#svBodystyle1").length) {
              $("#svBodystyle1").html(ckksvBodystyle);
            }
            $("#svfrReg").html(ckksvfrreg);
            createCookie("ckksvfrreg", ckksvfrreg, 1 / 12);
            if ($("#svfrReg1").length) {
              $("#svfrReg1").html(ckksvfrreg);
            }
            $("#svderivative").html(ckksvderivative);
            createCookie("ckksvderivative", ckksvderivative, 1 / 12);
            if ($("#svderivative1").length) {
              $("#svderivative1").html(ckksvderivative);
            }
            $("#vinno").html(vinno);
            createCookie("vinno", vinno, 1 / 12);
            if ($("#vinno1").length) {
              $("#vinno1").html(vinno);
              $("#vinno1label").show();
            }
            $("#regno").html(regno);
            $("#regnolabel").show();
            createCookie("regno", regno, 1 / 12);
            if ($("#regno1").length) {
              $("#regno1").html(regno);
              $("#regno1label").show();
            }
            $("#enginecode").html(enginecode);
            $("#enginecodelabel").show();
            createCookie("enginecode", enginecode, 1 / 12);
            if ($("#enginecode1").length) {
              $("#enginecode1").html(enginecode);
              $("#enginecode1label").show();
            }
            $("#doors").html(doors);
            $("#doorslabel").show();
            createCookie("doors", doors, 1 / 12);
            if ($("#doors1").length) {
              $("#doors1").html(doors);
              $("#doors1label").show();
            }
          } else {
            $.ajax({
              url: api_url1,
              type: "GET",
              error: function (response) {},
              success: function (result1) {
                result1 = (typeof result1 === "string") ? (typeof result1 === "string") ? JSON.parse(result1) : result1 : result1;
                var d = new Date(
                  result1.dvladata.registrationdate.firstregistration
                );
                var n = d.getFullYear();
                var date = n;
                var qstr = "";
                var qstr1 = "";
                var qstr2 = "";
                var qstr3 = "";
                var qstr4 = "";
                var qstr5 = "";
                if (Boolean(result1.enhanceddata.gcodedata.manufacturer)) {
                  $("#svManufacturer").html("");
                  $("#svManufacturer").html(
                    result1.enhanceddata.gcodedata.manufacturer
                  );
                  $("#showBtnchngvh").show();
                  if ($("#svManufacturer1").length) {
                    $("#svManufacturer1").html(
                      result1.enhanceddata.gcodedata.manufacturer
                    );
                    $("#showBtnchngvh").show();
                  }
                  createCookie(
                    "ckksvManufacturer",
                    result1.enhanceddata.gcodedata.manufacturer,
                    1 / 12
                  );
                }
                if (Boolean(result1.enhanceddata.gcodedata.model)) {
                  $("#svModel").html(result1.enhanceddata.gcodedata.model);
                  createCookie(
                    "ckksvModel",
                    result1.enhanceddata.gcodedata.model,
                    1 / 12
                  );
                  if ($("#svModel1").length) {
                    $("#svModel1").html(result1.enhanceddata.gcodedata.model);
                  }
                }
                if (Boolean(date)) {
                  $("#svYear").html(date);
                  if ($("#svYear1").length) {
                    $("#svYear1").html(date);
                  }
                  createCookie("ckksvYear", date, 1 / 12);
                }
                if (Boolean(result1.enhanceddata.gcodedata.engine.size.litre)) {
                  $("#svEngine").html(
                    result1.enhanceddata.gcodedata.engine.size.litre
                  );
                  if ($("#svEngine1").length) {
                    $("#svEngine1").html(
                      result1.enhanceddata.gcodedata.engine.size.litre
                    );
                  }
                  createCookie(
                    "ckksvEngine",
                    result1.enhanceddata.gcodedata.engine.size.litre,
                    1 / 12
                  );
                }
                if (Boolean(result1.enhanceddata.gcodedata.fueltype)) {
                  $("#svFuel").html(result1.enhanceddata.gcodedata.fueltype);
                  if ($("#svFuel1").length) {
                    $("#svFuel1").html(result1.enhanceddata.gcodedata.fueltype);
                  }
                  createCookie(
                    "ckksvFuel",
                    result1.enhanceddata.gcodedata.fueltype,
                    1 / 12
                  );
                }
                if (Boolean(result1.enhanceddata.gcodedata.bodystyle)) {
                  $("#svBodystyle").html(
                    result1.enhanceddata.gcodedata.bodystyle
                  );
                  if ($("#svBodystyle1").length) {
                    $("#svBodystyle1").html(
                      result1.enhanceddata.gcodedata.bodystyle
                    );
                  }
                  createCookie(
                    "ckksvBodystyle",
                    result1.enhanceddata.gcodedata.bodystyle,
                    1 / 12
                  );
                }
                if (
                  Boolean(result1.dvladata.registrationdate.firstregistration)
                ) {
                  var d = new Date(
                    result1.dvladata.registrationdate.firstregistration
                  );
                  var dd = d.getDate();
                  var mm = d.getMonth() + 1;
                  var yyyy = d.getFullYear();
                  if (dd < 10) {
                    dd = "0" + dd;
                  }
                  if (mm < 10) {
                    mm = "0" + mm;
                  }
                  var frregtoday = dd + "/" + mm + "/" + yyyy;
                  $("#svfrReg").html(frregtoday);
                  createCookie("ckksvfrreg", frregtoday, 1 / 12);
                  if ($("#svfrReg1").length) {
                    $("#svfrReg1").html(frregtoday);
                  }
                }
                if (Boolean(result1.enhanceddata.gcodedata.derivative)) {
                  $("#svderivative").html(
                    result1.enhanceddata.gcodedata.derivative
                  );
                  createCookie(
                    "ckksvderivative",
                    result1.enhanceddata.gcodedata.derivative,
                    1 / 12
                  );
                  if ($("#svderivative1").length) {
                    $("#svderivative1").html(
                      result1.enhanceddata.gcodedata.derivative
                    );
                  }
                }
                if (Boolean(result1.identifiers.vin)) {
                  $("#vinno").html(result1.identifiers.vin);
                  createCookie("vinno", result1.identifiers.vin, 1 / 12);

                  if ($("#vinno").length) {
                    $("#vinnolabel").show();
                  }
                  if ($("#vinno1").length) {
                    $("#vinnolabel1").show();
                    $("#vinno1").html(result1.identifiers.vin);
                  }
                }
                if (Boolean(result1.identifiers.vrm)) {
                  $("#regno").html(result1.identifiers.vrm);
                  $("#regnolabel").show();
                  createCookie("regno", result1.identifiers.vrm, 1 / 12);
                  if ($("#regno1").length) {
                    $("#regnolabel1").show();
                    $("#regno1").html(result1.identifiers.vrm);
                  }
                }
                if (Boolean(result1.identifiers.vrm)) {
                  $("#enginecode").html(
                    result1.enhanceddata.gcodedata.engine.code
                  );
                  createCookie(
                    "enginecode",
                    result1.enhanceddata.gcodedata.engine.code,
                    1 / 12
                  );
                  $("#enginecodelabel").show();
                  if ($("#enginecode1").length) {
                    $("#enginecodelabel1").show();
                    $("#enginecode1").html(
                      result1.enhanceddata.gcodedata.engine.code
                    );
                  }
                }
                if (Boolean(result1.identifiers.vrm)) {
                  $("#doors").html(result1.enhanceddata.gcodedata.doorcount);
                  createCookie(
                    "doors",
                    result1.enhanceddata.gcodedata.doorcount,
                    1 / 12
                  );
                  $("#doorslabel").show();
                  if ($("#doors1").length) {
                    $("#doorslabel1").show();
                    $("#doors1").html(result1.enhanceddata.gcodedata.doorcount);
                  }
                }
              },
              statusCode: {
                404: function () {
                  $("#vsrcresult").html("No record found");
                },
                400: function () {
                  $("#vsrcresult").html("No record found");
                },
                403: function () {
                  $("#vsrcresult").html("No record found");
                },
              },
            });
          }
        }
        $("#vcomponent").html("");
        if ($("#vcomponent").length) {
          $("#vcomponent").html("");
          if (
            localStorage.getItem("bodysubcatsrc") &&
            localStorage.getItem("bodysubcatsrc") != "" &&
            localStorage.getItem("bodysubcatsrc") != null &&
            localStorage.getItem("bodysubcatsrc") !== null &&
            localStorage.getItem("bodysubcatsrc") != undefined
          ) {
            $("#vcomponent").html(localStorage.getItem("bodysubcatsrc"));
          }
        }
        var is_call_body_api = 0;
        var is_call_body_api_bodysubcat = 0;
        var is_call_body_api_bodysubcatsrc = 0;
        if (
          localStorage.getItem("bodysubcat") &&
          localStorage.getItem("bodysubcat") != "" &&
          localStorage.getItem("bodysubcat") != null &&
          localStorage.getItem("bodysubcat") !== null &&
          localStorage.getItem("bodysubcat") != undefined
        ) {
          $("#100001").html(localStorage.getItem("bodysubcat"));
          is_call_body_api_bodysubcat = 1;
          for (let v = 1; v < 10; v++) {
            var p = 1;
            p = v * 1000;
            setTimeout(function () {
              if ($("#100001").length) {
                $("#100001").html("");

                if (
                  localStorage.getItem("bodysubcat") &&
                  localStorage.getItem("bodysubcat") != "" &&
                  localStorage.getItem("bodysubcat") != null &&
                  localStorage.getItem("bodysubcat") !== null &&
                  localStorage.getItem("bodysubcat") != undefined
                ) {
                  $("#100001").html(localStorage.getItem("bodysubcat"));
                }
              }
            }, p);
          }
        }
        if (
          localStorage.getItem("bodysubcatsrc") &&
          localStorage.getItem("bodysubcatsrc") != "" &&
          localStorage.getItem("bodysubcatsrc") != null &&
          localStorage.getItem("bodysubcatsrc") !== null &&
          localStorage.getItem("bodysubcatsrc") != undefined
        ) {
          $("#vcomponent").html(localStorage.getItem("bodysubcatsrc"));
          is_call_body_api_bodysubcatsrc = 1;
          for (let v = 1; v < 10; v++) {
            var p = 1;
            p = v * 1000;
            setTimeout(function () {
              $("#vcomponent").html("");
              $("#vcomponent").html(localStorage.getItem("bodysubcatsrc"));
            }, p);
          }
        }
        if (
          is_call_body_api_bodysubcatsrc == 0 ||
          is_call_body_api_bodysubcat == 0
        ) {
        }        
      }
    });
  }
  if (isEmpty(parameters) == false) {
    $.each(parameters, function (key, value) {
      if (key == "mk") {
        mk = value;
      }
      if (key == "md") {
        md = value;
      }
      if (key == "mdv") {
        mdv = value;
      }
      if (key == "eng") {
        eng = value;
      }
      if (key == "btyp") {
        btyp = value;
      }
      if (key == "der") {
        der = value;
      }
      if (key == "fuel") {
        fuel = value;
      }
      if (key == "trt") {
        trt = value;
      }
    });
    let mkname = localStorage.getItem("mkname");
    let mdname = localStorage.getItem("mdname");
    let mdvname = localStorage.getItem("mdvname");
    if (md != "" && mk != "") {
      $("#adgpartial").css("display", "none !important");
      var ckkmanufacturer;
      ckkmanufacturer =
        localStorage.ckkmanufacturer3;
      if (
        ckkmanufacturer !== null &&
        ckkmanufacturer != "" &&
        ckkmanufacturer !== undefined
      ) {
        var parsedObj = JSON.parse(ckkmanufacturer);
        for (var i = 0; i < parsedObj.manufacturers.length; ++i) {
          $("#vmake").append(
            new Option(
              parsedObj.manufacturers[i].value,
              parsedObj.manufacturers[i].fieldid
            )
          );
        }
        $("#vmake option[value=" + mk + "]").prop("selected", "selected");
        $("#vmake [value=" + mk + "]").attr("selected", "true");
        $("#svManufacturer").html("");
        $("#svManufacturer").html($("#vmake option[value=" + mk + "]").text());
        $("#showBtnchngvh").show();
        if ($("#svManufacturer1").length) {
          $("#svManufacturer1").html(
            $("#vmake option[value=" + mk + "]").text()
          );
          $("#showBtnchngvh").show();
        }
        $("#adgpartial").css("display", "none !important");
        getmodelvalsrch(mk, md);
        getyearvalsrch(mk, md, mdv);
        getenginevalsrch(mk, md, mdv, eng);
        getbodystylesvalsrch(mk, md, mdv, eng, btyp);
        getderivativesvalsrch(mk, md, mdv, eng, btyp, der);
        getfueltypevalsrch(mk, md, mdv, eng, btyp, der, fuel);
        gettransmissiontypevalsrch(mk, md, mdv, eng, btyp, der, fuel, trt);
        $("#adgpartial").hide();
        if ($(".autovrmdata1").length) {
          const mq1 = window.matchMedia("(min-width: 749px)");
          if ($("#100001").length) {
            $("#100001").html("");
            if (
              localStorage.getItem("bodysubcat") &&
              localStorage.getItem("bodysubcat") != "" &&
              localStorage.getItem("bodysubcat") != null &&
              localStorage.getItem("bodysubcat") !== null &&
              localStorage.getItem("bodysubcat") != undefined
            ) {
              $("#100001").html(localStorage.getItem("bodysubcat"));
            }
          }
          if (mq1.matches) {
            $(".autovrmdata").show();
            $(".autovrmdata1").hide();
            if ($("#vcomponent").length) {
              $("#vcomponent").html("");
              if (
                localStorage.getItem("bodysubcatsrc") &&
                localStorage.getItem("bodysubcatsrc") != "" &&
                localStorage.getItem("bodysubcatsrc") != null &&
                localStorage.getItem("bodysubcatsrc") !== null &&
                localStorage.getItem("bodysubcatsrc") != undefined
              ) {
                $("#vcomponent").html(localStorage.getItem("bodysubcatsrc"));
              }
            }
          } else {
            $(".autovrmdata1").show();
            $(".autovrmdata").hide();
            if ($("#vcomponent").length) {
              $("#vcomponent").html("");
              if (
                localStorage.getItem("bodysubcatsrc") &&
                localStorage.getItem("bodysubcatsrc") != "" &&
                localStorage.getItem("bodysubcatsrc") != null &&
                localStorage.getItem("bodysubcatsrc") !== null &&
                localStorage.getItem("bodysubcatsrc") != undefined
              ) {
                $("#vcomponent").html(localStorage.getItem("bodysubcatsrc"));
              }
            }
          }
        } else {
          $(".autovrmdata").show();

          if ($("#vcomponent").length) {
            $("#vcomponent").html("");
            if (
              localStorage.getItem("bodysubcatsrc") &&
              localStorage.getItem("bodysubcatsrc") != "" &&
              localStorage.getItem("bodysubcatsrc") != null &&
              localStorage.getItem("bodysubcatsrc") !== null &&
              localStorage.getItem("bodysubcatsrc") != undefined
            ) {
              $("#vcomponent").html(localStorage.getItem("bodysubcatsrc"));
            }
          }
          if ($("#100001").length) {
            $("#100001").html("");

            if (
              localStorage.getItem("bodysubcat") &&
              localStorage.getItem("bodysubcat") != "" &&
              localStorage.getItem("bodysubcat") != null &&
              localStorage.getItem("bodysubcat") !== null &&
              localStorage.getItem("bodysubcat") != undefined
            ) {
              $("#100001").html(localStorage.getItem("bodysubcat"));
            }
          }
        }
        $("#svfrRegth").hide();
        $("#svfrRegs").hide();
        if ($("#svfrRegth1").length) {
          $("#svfrRegth1").hide();
        }
        if ($("#svfrRegs1").length) {
          $("#svfrRegs1").hide();
        }
      } else {
        var api_urlmake =
          adgurlNew +
          "api_id=72850&ip=" +
          (getCookie("user_ip_tracking") || "0") +
          "&function_id=else973&vehicletypes=" +
          getCookie("vtype");
        $.ajax({
          url: api_urlmake,
          type: "GET",
          contentType: "application/json",
          ataType: "json",
          success: function (result1) {
            var parsedObj = (typeof result1 === "string") ? JSON.parse(result1) : result1;
            localStorage.ckkmanufacturer3 = JSON.stringify(parsedObj);
            for (var i = 0; i < parsedObj.manufacturers.length; ++i) {
              $("#vmake").append(
                new Option(
                  parsedObj.manufacturers[i].value,
                  parsedObj.manufacturers[i].fieldid
                )
              );
            }
            $("#vmake option[value=" + mk + "]").prop("selected", "selected");
            $("#vmake [value=" + mk + "]").attr("selected", "true");
            $("#svManufacturer").html("");
            $("#svManufacturer").html(
              $("#vmake option[value=" + mk + "]").text()
            );
            $("#showBtnchngvh").show();
            if ($("#svManufacturer1").length) {
              $("#svManufacturer1").html(
                $("#vmake option[value=" + mk + "]").text()
              );
              $("#showBtnchngvh").show();
            }
            getmodelvalsrch(mk, md);
            getyearvalsrch(mk, md, mdv);
            getenginevalsrch(mk, md, mdv, eng);
            getbodystylesvalsrch(mk, md, mdv, eng, btyp);
            getderivativesvalsrch(mk, md, mdv, eng, btyp, der);
            getfueltypevalsrch(mk, md, mdv, eng, btyp, der, fuel);
            gettransmissiontypevalsrch(mk, md, mdv, eng, btyp, der, fuel, trt);
            $("#adgpartial").css("display", "none !important");
            $("#adgpartial").hide();
            if ($(".autovrmdata1").length) {
              const mq1 = window.matchMedia("(min-width: 749px)");
              if ($("#100001").length) {
                $("#100001").html("");
                if (
                  localStorage.getItem("bodysubcat") &&
                  localStorage.getItem("bodysubcat") != "" &&
                  localStorage.getItem("bodysubcat") != null &&
                  localStorage.getItem("bodysubcat") !== null &&
                  localStorage.getItem("bodysubcat") != undefined
                ) {
                  $("#100001").html(localStorage.getItem("bodysubcat"));
                }
              }
              if (mq1.matches) {
                $(".autovrmdata").show();

                $(".autovrmdata1").hide();
              } else {
                $(".autovrmdata1").show();
                $(".autovrmdata").hide();
              }
            } else {
              if ($("#100001").length) {
                $("#100001").html("");
                if (
                  localStorage.getItem("bodysubcat") &&
                  localStorage.getItem("bodysubcat") != "" &&
                  localStorage.getItem("bodysubcat") != null &&
                  localStorage.getItem("bodysubcat") !== null &&
                  localStorage.getItem("bodysubcat") != undefined
                ) {
                  $("#100001").html(localStorage.getItem("bodysubcat"));
                }
              }
              $(".autovrmdata").show();
              if ($("#100001").length) {
                $("#100001").html("");
                if (
                  localStorage.getItem("bodysubcat") &&
                  localStorage.getItem("bodysubcat") != "" &&
                  localStorage.getItem("bodysubcat") != null &&
                  localStorage.getItem("bodysubcat") !== null &&
                  localStorage.getItem("bodysubcat") != undefined
                ) {
                  $("#100001").html(localStorage.getItem("bodysubcat"));
                }
              }
            }
            $("#svfrRegth").hide();
            $("#svfrRegs").hide();
            if ($("#svfrRegth1").length) {
              $("#svfrRegth1").hide();
            }
            if ($("#svfrRegs1").length) {
              $("#svfrRegs1").hide();
            }
          },
          statusCode: {
            404: function () {
              $("#vsrcresult").html("No record found");
            },
            400: function () {
              $("#vsrcresult").html("No record found");
            },
            403: function () {
              $("#vsrcresult").html("No record found");
            },
          },
        });
      }
     /* console.log("bodysubcatsrc" + localStorage.getItem("bodysubcatsrc"));
      console.log("bodysubcat" + localStorage.getItem("bodysubcat"));*/
      if (
        localStorage.getItem("bodysubcat") &&
        localStorage.getItem("bodysubcat") != "" &&
        localStorage.getItem("bodysubcat") != null &&
        localStorage.getItem("bodysubcat") !== null &&
        localStorage.getItem("bodysubcat") != undefined
      ) {
        if ($("#vcomponent").length) {
          for (let v = 1; v < 10; v++) {
            var p = 1;
            p = v * 1000;
            setTimeout(function () {
              $("#vcomponent").html("");
              $("#vcomponent").html(
                '<ul class="m-0 p-0 leftmenulist bg-white font-w-regular  mCustomScrollbar" data-mcs-theme="dark"><li class="active"><a class="replacementparts-menu " href="#replacementparts" data-toggle="collapse" data-target="#adgbody"><span class="100001 left-menuicon"><img src="https://trv.dev-env.pro/images/assets/icon-body.png" alt=""></span> <span>Body</span></a><ul id="adgbody" class="collapse show">' +
                  localStorage.getItem("bodysubcat") +
                  "</ul></li></ul>"
              );
            }, p);
          }
        }
      }      
    }
    /* get partial id end */
  }
}
/* vehicle reg no catalog end */
/* quantity max limit start */
jQuery(function () {
  jQuery("#Quantity-product-template").change(function () {
    var max = 3;
    var min = 1;
    if (jQuery(this).val() > max) {
      jQuery(this).val(max);
    } else if (jQuery(this).val() < min) {
      jQuery(this).val(min);
    }
  });
});
jQuery(function () {
  jQuery(".cart__qty-input").change(function () {    
    var max = 10;
    var min = 1;
    if (jQuery(this).val() > max) {
      jQuery(this).val(max);
    } else if (jQuery(this).val() < min) {
      jQuery(this).val(min);
    }
  });
});
/* quantity max limit end */
/* get make model and filter options start*/
$(document).ready(function () {
  var parameters = getQueryStringParameters();
  if (isEmpty(parameters) == true) {    
    get_manufactures(0);
    if(getCookie("ckkautog"))
    {
      $("#breadcrumbvrm").hide();
        $("#openPopup").hide();
    }else if(localStorage.ckksrcmake)
    {
      $("#breadcrumbvrm").hide();
        $("#openPopup").hide();
    }
  } else {
    get_manufactures(getCookie("vtype"));
    $.each(parameters, function (key, value) {
      if (key == "autog") {
        $("#breadcrumbvrm").hide();
        $("#openPopup").hide();
      } else if (key == "mk") {
        $("#breadcrumbvrm").hide();
        $("#openPopup").hide();
      }
    });
  }
});
function get_manufactures(vtype) {
  if (vtype != "" && vtype !== null && vtype != "0") {
    $("#vmake").prop("disabled", false);
  } else {
    $("#vmake").prop("disabled", true);
  }
  $("#vmodel").empty();
  $("#vmodelver").empty();
  $("#vmodel").append(new Option("Model", ""));
  $("#vmodelver").append(new Option("Model Version", ""));
  $("#vmodel").prop("disabled", true);
  $("#vmodelver").prop("disabled", true);
  $("#vmodeleng").prop("disabled", true);
  $("#vmodelbodystyles").prop("disabled", true);
  $("#vmodelderivatives").prop("disabled", true);
  $("#vfueltype").prop("disabled", true);
  $("#vtransmissiontype").prop("disabled", true);
  var ckkmanufacturer;
  ckkmanufacturer =
    localStorage.ckkmanufacturer3;
  if (
    ckkmanufacturer !== null &&
    ckkmanufacturer != undefined &&
    ckkmanufacturer != "" &&
    getCookie("vtype") == vtype
  ) {
    var parsedObj = JSON.parse(ckkmanufacturer);
    for (var i = 0; i < parsedObj.manufacturers.length; ++i) {
      $("#vmake").append(
        new Option(
          parsedObj.manufacturers[i].value,
          parsedObj.manufacturers[i].fieldid
        )
      );
    }
    var ckksvManufi = localStorage.ckksrcmake;
    if (ckksvManufi != "" && ckksvManufi !== null && ckksvManufi != undefined) {
      $("#vmake option[value=" + ckksvManufi + "]").prop(
        "selected",
        "selected"
      );
      $("#vmake [value=" + ckksvManufi + "]").attr("selected", "true");
      if ($("#svManufacturer").text() == "") {
        $("#svManufacturer").html("");
        $("#svManufacturer").html(
          $("#vmake option[value=" + ckksvManufi + "]").text()
        );
        $("#showBtnchngvh").show();
        if ($("#svManufacturer1").length) {
          $("#showBtnchngvh").show();
          $("#svManufacturer1").html(
            $("#vmake option[value=" + mk + "]").text()
          );
        }
        $("#svManufacturer").html(localStorage.ckkmanufacturerLVC);
      }
    }
  } else {
    if(vtype!='' || vtype != null){
     vtype=3; 
    }
    
    createCookie("vtype", vtype, 1 / 12);
    var api_urlmake =
      adgurlNew +
      "api_id=72850&ip=" +
      (getCookie("user_ip_tracking") || "0") +
      "&function_id=MANUFACTURE&vehicletypes=" +
      getCookie("vtype");
    $.ajax({
      url: api_urlmake,
      type: "GET",
      dataType: "json",
      success: function (result2) {
        var stringified = JSON.stringify(result2);
        var parsedObj = JSON.parse(stringified);
        localStorage.ckkmanufacturer3 = JSON.stringify(parsedObj);
        for (var i = 0; i < parsedObj.manufacturers.length; ++i) {
          $("#vmake").append(
            new Option(
              parsedObj.manufacturers[i].value,
              parsedObj.manufacturers[i].fieldid
            )
          );
        }
        var ckksvManufi = localStorage.ckksrcmake;
        if (
          ckksvManufi != "" &&
          ckksvManufi !== null &&
          ckksvManufi != undefined
        ) {
          $("#vmake option[value=" + ckksvManufi + "]").prop(
            "selected",
            "selected"
          );
          $("#vmake [value=" + ckksvManufi + "]").attr("selected", "true");
        }
      },
      statusCode: {
        404: function () {
          //$("#vsrcresult").html("No record found");
        },
        400: function () {
        //  $("#vsrcresult").html("No record found");
        },
        403: function () {
          //$("#vsrcresult").html("No record found");
        },
      },
    });
    // }
  }
}
/*  get make model and filter options  end */
/* get model based on make selection start */
function getmodelval(sel) {
  $("#vmodel").prop("disabled", true);
  $("#vmodelver").prop("disabled", true);
  $("#vmodeleng").prop("disabled", true);
  $("#vmodelbodystyles").prop("disabled", true);
  $("#vmodelderivatives").prop("disabled", true);
  $("#vfueltype").prop("disabled", true);
  $("#vtransmissiontype").prop("disabled", true);
  localStorage.ckkmanufacturerLVC = $(
    "#vmake option[value=" + sel.value + "]"
  ).text();
  $("#vmodel").empty();
  $("#vmodel").append(new Option("Loading...", ""));
  $("#vmodel").css(
    "background-image",
    "url('https://cdn.shopify.com/s/files/1/0269/6327/9935/files/adgloding.gif?v=1611224423'"
  );
  $("#vmodelver").empty();
  $("#vmodelver").append(new Option("Model Version", ""));
  // var api_urlmodel = adgurl + "V2/country/GB/partiallookup/vehicletype/3/manufacturer/" + sel.value + "/model";
  var api_urlmodel =
    adgurlNew +
    "api_id=72856&manufacturer=" +
    sel.value +
    "&ip=" +
    (getCookie("user_ip_tracking") || "0") +
    "&function_id=getmodelval&vehicletypes=" +
    getCookie("vtype");
  $.ajax({
    url: api_urlmodel,
    type: "GET",
    success: function (result2) {
      var parsedObj = (typeof result2 === "string") ? JSON.parse(result2) : result2;
      localStorage.ckkvmodel = JSON.stringify(parsedObj);
      $("#vmodel").prop("disabled", false);
      $("#vmodel").empty();
      $("#vmodel").append(new Option("Model", ""));
      $("#vmodel").css("background-image", "");
      for (var i = 0; i < parsedObj.models.length; ++i) {
        $("#vmodel").append(
          new Option(parsedObj.models[i].value, parsedObj.models[i].fieldid)
        );
      }
    },
    statusCode: {
      404: function () {
        $("#vsrcresult").html("No record found");
      },
      400: function () {
        $("#vsrcresult").html("No record found");
      },
      403: function () {
        $("#vsrcresult").html("No record found");
      },
    },
  });
}
/* get model based on make selection end */
/* get year based on make and model selection start */
function getyearval(sel) {
  $("#vmodelver").empty();
  $("#vmodelver").append(new Option("Loading...", ""));
  $("#vmodelver").css(
    "background-image",
    "url('https://cdn.shopify.com/s/files/1/0269/6327/9935/files/adgloding.gif?v=1611224423'"
  );
  $("#vmodelver").prop("disabled", true);
  //var api_urlyear = adgurl+"V2/country/GB/partiallookup/vehicletype/3/manufacturer/" + $("select#vmake option").filter(":selected").val() + "/model/" + sel.value + "";
  var api_urlyear =
    adgurlNew +
    "api_id=72858&manufacturer=" +
    $("select#vmake option").filter(":selected").val() +
    "&model=" +
    sel.value +
    "&ip=" +
    (getCookie("user_ip_tracking") || "0") +
    "&function_id=getyearval&vehicletypes=" +
    getCookie("vtype");
  //var api_urlyear =adgurl+"V2/country/GB/partiallookup/vehicletype/3/manufacturer/173/model/4168";
  $.ajax({
    url: api_urlyear,
    type: "GET",
    success: function (result2) {      
      var parsedObj = (typeof result2 === "string") ? JSON.parse(result2) : result2;
      localStorage.ckkvmodelver = JSON.stringify(parsedObj.modelversions);
      $("#vmodelver").empty();
      $("#vmodelver").append(new Option("Model Version", ""));
      $("#vmodelver").css("background-image", "");
      $("#vmodelver").prop("disabled", false);
      for (var i = 0; i < parsedObj.modelversions.length; ++i) {
        $("#vmodelver").append(
          new Option(
            parsedObj.modelversions[i].value,
            parsedObj.modelversions[i].fieldid
          )
        );
      }
    },
    statusCode: {
      404: function () {
        $("#vsrcresult").html("No record found");
      },
      400: function () {
        $("#vsrcresult").html("No record found");
      },
      403: function () {
        $("#vsrcresult").html("No record found");
      },
    },
  });
}
/* get year based on make and model  selection end */
/* get engine based on make and model selection start */
function getengine(sel) {
  $("#vmodeleng").empty();
  $("#vmodeleng").append(new Option("Loading...", ""));
  $("#vmodeleng").css(
    "background-image",
    "url('https://cdn.shopify.com/s/files/1/0269/6327/9935/files/adgloding.gif?v=1611224423'"
  );
  $("#vmodeleng").prop("disabled", true);
  var api_urlyear =
    adgurlNew +
    "api_id=72860&manufacturer=" +
    $("select#vmake option").filter(":selected").val() +
    "&model=" +
    $("select#vmodel option").filter(":selected").val() +
    "&ModelVersionID=" +
    sel.value +
    "&ip=" +
    (getCookie("user_ip_tracking") || "0") +
    "&function_id=getengine&vehicletypes=" +
    getCookie("vtype");
  $.ajax({
    url: api_urlyear,
    type: "GET",
    success: function (result2) {
      var parsedObj = (typeof result2 === "string") ? JSON.parse(result2) : result2;
      localStorage.ckkvmodeleng = JSON.stringify(parsedObj.engineccs);
      $("#vmodeleng").empty();
      $("#vmodeleng").append(new Option("Engine CC", ""));
      $("#vmodeleng").prop("disabled", false);
      $("#vmodeleng").css("background-image", "");
      for (var i = 0; i < parsedObj.engineccs.length; ++i) {
        $("#vmodeleng").append(
          new Option(
            parsedObj.engineccs[i].value,
            parsedObj.engineccs[i].fieldid
          )
        );
      }
    },
    statusCode: {
      404: function () {
        $("#vsrcresult").html("No record found");
      },
      400: function () {
        $("#vsrcresult").html("No record found");
      },
      403: function () {
        $("#vsrcresult").html("No record found");
      },
    },
  });
}
/* get engine based on make and model  selection end */
/* get body type based on make and model selection start */
function getbodytype(sel) {
  $("#vmodelbodystyles").empty();
  $("#vmodelbodystyles").append(new Option("Loading...", ""));
  $("#vmodelbodystyles").css(
    "background-image",
    "url('https://cdn.shopify.com/s/files/1/0269/6327/9935/files/adgloding.gif?v=1611224423'"
  );
  $("#vmodelbodystyles").prop("disabled", true);
  var api_urlyear =
    adgurlNew +
    "api_id=72860&manufacturer=" +
    $("select#vmake option").filter(":selected").val() +
    "&model=" +
    $("select#vmodel option").filter(":selected").val() +
    "&ModelVersionID=" +
    $("select#vmodelver option").filter(":selected").val() +
    "&EngineCC=" +
    sel.value +
    "&ip=" +
    (getCookie("user_ip_tracking") || "0") +
    "&function_id=getbodytype&vehicletypes=" +
    getCookie("vtype");
  $.ajax({
    url: api_urlyear,
    type: "GET",
    // contentType: "application/json",
    //          ataType: 'json',
    success: function (result2) {
      var parsedObj = (typeof result2 === "string") ? JSON.parse(result2) : result2;
      localStorage.ckkvmodelbodystyles = JSON.stringify(parsedObj.bodystyles);
      $("#vmodelbodystyles").empty();
      $("#vmodelbodystyles").append(new Option("Body Style", ""));
      $("#vmodelbodystyles").prop("disabled", false);
      $("#vmodelbodystyles").css("background-image", "");
      for (var i = 0; i < parsedObj.bodystyles.length; ++i) {
        $("#vmodelbodystyles").append(
          new Option(
            parsedObj.bodystyles[i].value,
            parsedObj.bodystyles[i].fieldid
          )
        );
      }
    },
    statusCode: {
      404: function () {
        $("#vsrcresult").html("No record found");
      },
      400: function () {
        $("#vsrcresult").html("No record found");
      },
      403: function () {
        $("#vsrcresult").html("No record found");
      },
    },
  });
}
/* get body type based on make and model  selection end */
/* get Derivatives based on make and model selection start */
function getderivatives(sel) {
  $("#vmodelderivatives").empty();
  $("#vmodelderivatives").append(new Option("Loading...", ""));
  $("#vmodelderivatives").css(
    "background-image",
    "url('https://cdn.shopify.com/s/files/1/0269/6327/9935/files/adgloding.gif?v=1611224423'"
  );
  $("#vmodelderivatives").prop("disabled", true);
  var api_urlyear =
    adgurlNew +
    "api_id=72860&manufacturer=" +
    $("select#vmake option").filter(":selected").val() +
    "&model=" +
    $("select#vmodel option").filter(":selected").val() +
    "&ModelVersionID=" +
    $("select#vmodelver option").filter(":selected").val() +
    "&EngineCC=" +
    $("select#vmodeleng option").filter(":selected").val() +
    "&BodyStyleID=" +
    sel.value +
    "&ip=" +
    (getCookie("user_ip_tracking") || "0") +
    "&function_id=getderivatives&vehicletypes=" +
    getCookie("vtype");
  $.ajax({
    url: api_urlyear,
    type: "GET",
    //  contentType: "application/json",
    //ataType: 'json',
    success: function (result2) {
      var parsedObj = (typeof result2 === "string") ? JSON.parse(result2) : result2;
      localStorage.ckkvmodelderivatives = JSON.stringify(parsedObj.derivatives);
      $("#vmodelderivatives").empty();
      $("#vmodelderivatives").append(new Option("Derivatives", ""));
      $("#vmodelderivatives").css("background-image", "");
      $("#vmodelderivatives").prop("disabled", false);
      for (var i = 0; i < parsedObj.derivatives.length; ++i) {
        $("#vmodelderivatives").append(
          new Option(
            parsedObj.derivatives[i].value,
            parsedObj.derivatives[i].fieldid
          )
        );
      }
    },
    statusCode: {
      404: function () {
        $("#vsrcresult").html("No record found");
      },
      400: function () {
        $("#vsrcresult").html("No record found");
      },
      403: function () {
        $("#vsrcresult").html("No record found");
      },
    },
  });
}
/* get Derivatives based on make and model  selection end */
/* get fuel type based on make and model selection start */
function getfueltype(sel) {
  $("#vfueltype").empty();
  $("#vfueltype").append(new Option("Loading...", ""));
  $("#vfueltype").css(
    "background-image",
    "url('https://cdn.shopify.com/s/files/1/0269/6327/9935/files/adgloding.gif?v=1611224423'"
  );
  $("#vfueltype").prop("disabled", true);
  var api_urlyear =
    adgurlNew +
    "api_id=72860&manufacturer=" +
    $("select#vmake option").filter(":selected").val() +
    "&model=" +
    $("select#vmodel option").filter(":selected").val() +
    "&ModelVersionID=" +
    $("select#vmodelver option").filter(":selected").val() +
    "&EngineCC=" +
    $("select#vmodeleng option").filter(":selected").val() +
    "&BodyStyleID=" +
    $("select#vmodelbodystyles option").filter(":selected").val() +
    "&DerivativeID=" +
    sel.value +
    "&ip=" +
    (getCookie("user_ip_tracking") || "0") +
    "&function_id=getfueltype&vehicletypes=" +
    getCookie("vtype");
  $.ajax({
    url: api_urlyear,
    type: "GET",
    //contentType: "application/json",
    //ataType: 'json',
    success: function (result2) {
      var parsedObj = (typeof result2 === "string") ? JSON.parse(result2) : result2;
      localStorage.ckkvfueltype = JSON.stringify(parsedObj.fueltypes);
      $("#vfueltype").empty();
      $("#vfueltype").append(new Option("Fuel Type", ""));
      $("#vfueltype").css("background-image", "");
      $("#vfueltype").prop("disabled", false);
      for (var i = 0; i < parsedObj.fueltypes.length; ++i) {
        $("#vfueltype").append(
          new Option(
            parsedObj.fueltypes[i].value,
            parsedObj.fueltypes[i].fieldid
          )
        );
      }
    },
    statusCode: {
      404: function () {
        $("#vsrcresult").html("No record found");
      },
      400: function () {
        $("#vsrcresult").html("No record found");
      },
      403: function () {
        $("#vsrcresult").html("No record found");
      },
    },
  });
}
/* get fuel type based on make and model  selection end */
/* get transmission type based on make and model selection start */
function gettransmissiontype(sel) {
  $("#vtransmissiontype").empty();
  $("#vtransmissiontype").append(new Option("Loading...", ""));
  $("#vtransmissiontype").css(
    "background-image",
    "url('https://cdn.shopify.com/s/files/1/0269/6327/9935/files/adgloding.gif?v=1611224423'"
  );
  $("#vtransmissiontype").prop("disabled", true);
  var api_urlyear =
    adgurlNew +
    "api_id=72860&manufacturer=" +
    $("select#vmake option").filter(":selected").val() +
    "&model=" +
    $("select#vmodel option").filter(":selected").val() +
    "&ModelVersionID=" +
    $("select#vmodelver option").filter(":selected").val() +
    "&EngineCC=" +
    $("select#vmodeleng option").filter(":selected").val() +
    "&BodyStyleID=" +
    $("select#vmodelbodystyles option").filter(":selected").val() +
    "&DerivativeID=" +
    $("select#vmodelderivatives option").filter(":selected").val() +
    "&FuelTypeID=" +
    sel.value +
    "&ip=" +
    (getCookie("user_ip_tracking") || "0") +
    "&function_id=gettransmissiontype&vehicletypes=" +
    getCookie("vtype");
  $.ajax({
    url: api_urlyear,
    type: "GET",
    success: function (result2) {
      var parsedObj = (typeof result2 === "string") ? JSON.parse(result2) : result2;
      $("#vtransmissiontype").empty();
      $("#vtransmissiontype").append(new Option("Transmission Type", ""));
      $("#vtransmissiontype").css("background-image", "");
      $("#vtransmissiontype").prop("disabled", false);

      createCookie(
        "ckkvtransmissiontype",
        JSON.stringify(parsedObj.transmissiontypes),
        9
      );
      $("#vtransmissiontype").empty();
      $("#vtransmissiontype").append(new Option("Transmission Type", ""));
      $("#vtransmissiontype").css("background-image", "");
      $("#vtransmissiontype").prop("disabled", false);
      for (var i = 0; i < parsedObj.transmissiontypes.length; ++i) {
        $("#vtransmissiontype").append(
          new Option(
            parsedObj.transmissiontypes[i].value,
            parsedObj.transmissiontypes[i].fieldid
          )
        );
      }
    },
    statusCode: {
      404: function () {
        $("#vsrcresult").html("No record found");
      },
      400: function () {
        $("#vsrcresult").html("No record found");
      },
      403: function () {
        $("#vsrcresult").html("No record found");
      },
    },
  });
}
/* get transmission type based on make and model  selection end */
/* get product list baesd on components start */
function getlistoncomponent(compid, vrm) {
  $("#vsrcresult").html(
    '<img  loading="lazy" src="https://cdn.shopify.com/s/files/1/0269/6327/9935/files/ajaxloader.gif?v=1596625858" />'
  );
  //var api_urlcomp = adgurl+"V2/country/GB/vehicle/"+vrm+"/component/"+compid+"/parts";
  // var api_urlcomp = adgurl + "V2/country/GB/vehicle/" + vrm + "/component/" + compid + "/parts";
  var api_urlcomp =
    adgurlNew +
    "api_id=72862&vrm=" +
    vrm +
    "&componentID=" +
    compid +
    "&ip=" +
    (getCookie("user_ip_tracking") || "0") +
    "&pageulr=" +
    window.location.href;
  $.ajax({
    url: api_urlcomp,
    type: "GET",
    contentType: "application/json",
    ataType: "json",
    success: function (result2) {
      // $('#vsrcresult').html('<img src="https://cdn.shopify.com/s/files/1/0269/6327/9935/files/ajax-loader.gif?v=1596625384" />');
      $("#vsrcresulthdf").html("");
      // var stringified = JSON.stringify(result2);
      var parsedObj = (typeof result2 === "string") ? JSON.parse(result2) : result2;

      for (var i = 0; i < parsedObj.parts.length; ++i) {
        if (i == 0) {
          $("#vsrcresulthdf").append(
            "'" + parsedObj.parts[i][0].oenumber + "'"
          );
        } else {
          $("#vsrcresulthdf").append(
            "+OR+'" + parsedObj.parts[i][0].oenumber + "'"
          );
        }
        //https://tradevehicleparts-co-uk.myshopify.com/search?type=product&q=variants.sku:DS1030+OR+DS5059&view=sku
      }
      window.location.href =
        siteurls +
        "/search?type=product&q=variants.sku:" +
        $("#vsrcresulthdf").text() +
        "&view=sku&autog=" +
        vrm;
    },
    statusCode: {
      404: function (err) {
        // alert('Please try another VRM, component ID, or contact the administrator.');
        $("#vsrcresult").html('<hr aria-hidden="true">No record found');
      },
      400: function () {
        $("#vsrcresult").html('<hr aria-hidden="true">No record found');
      },
      403: function () {
        $("#vsrcresult").html('<hr aria-hidden="true">No record found');
      },
    },
  });
}
/* get product list baesd on components end */
/* get partial id for search start */
function getproductecode() {
  var ckkautog = getCookie("ckkautog") || sessionStorage.getItem("tvp_reg") || "";
  var vihclenumberfit = getCookie("vihclenumberfit");
  if (ckkautog != "" && ckkautog !== null && typeof ckkautog != "undefined") {
    if (
      localStorage.getItem("vrmsrchurl") &&
      localStorage.getItem("vrmsrchurl") != "" &&
      localStorage.getItem("vrmsrchurl") != null &&
      localStorage.getItem("vrmsrchurl") !== null &&
      localStorage.getItem("vrmsrchurl") != undefined
    ) {
      window.location.replace(localStorage.getItem("vrmsrchurl"));
    } else {
      $("#vihclenumber").val(ckkautog);
      $("#button").trigger("click");
    }
  } else if (
    vihclenumberfit !== null &&
    vihclenumberfit != "" &&
    vihclenumberfit !== undefined
  ) {
    $("#vihclenumber").val(vihclenumberfit);
    $("#button").trigger("click");
  } else {
    if (
      localStorage.getItem("manualsrchurl") &&
      localStorage.getItem("manualsrchurl") != "" &&
      localStorage.getItem("manualsrchurl") != null &&
      localStorage.getItem("manualsrchurl") !== null &&
      localStorage.getItem("manualsrchurl") != undefined
    ) {
      window.location.replace(localStorage.getItem("manualsrchurl"));
      return false;
    }
    var srcmake = $("#vmake option:selected").val();
    var srcmodel = $("#vmodel option:selected").val();
    var srcmodelver = $("#vmodelver option:selected").val();
    var srcmodeleng = $("#vmodeleng option:selected").val();
    var srcmodelbodystyles = $("#vmodelbodystyles option:selected").val();
    var srcmodelderivatives = $("#vmodelderivatives option:selected").val();
    var srcvfueltype = $("#vfueltype option:selected").val();
    var srcvtransmissiontype = $("#vtransmissiontype option:selected").val();
    createCookie("ckkautog", "", -1);
    createCookie("vrmsrchsku", "", -1);
    if (srcmake == "") {
      alert("Please select Make");
      return false;
    }
    if (srcmodel == "") {
      alert("Please select Model");
      return false;
    }
    if (srcmodelver == "") {
      alert("Please select Model Version");
      return false;
    }
    if (srcmodeleng == "") {
      alert("Please select Engine CC");
      return false;
    }
    if (srcmodelbodystyles == "") {
      alert("Please select Body Style");
      return false;
    }
    if (srcmodelderivatives == "") {
      alert("Please select Derivatives");
      return false;
    }
    if (srcvfueltype == "") {
      alert("Please select Fuel Type");
      return false;
    }
    if (srcvtransmissiontype == "") {
      alert("Please select Transmission Type");
      return false;
    }
    tvp_ip_tracking_if_consented(3);
    localStorage.setItem("mkname", $("#vmake option:selected").text());
    localStorage.setItem("mdname", $("#vmodel option:selected").text());
    localStorage.setItem("mdvname", $("#vmodelver option:selected").text());
    localStorage.setItem(
      "mdvmodelderivatives",
      $("#vmodelderivatives option:selected").text()
    );
    ip_tracking = getCookie("ip_tracking");
    if (ip_tracking !== null && ip_tracking == 0 && ip_tracking != "") {
      alert(
        "Sorry you have reached your VRM lookup limit for today. If you require a bigger daily limit, please let us know. You can either call us on 0116 319 6543, send us an email at sales@tradevehicleparts.co.uk, or get in touch on the live chat. Thanks!"
      );
      return false;
    }
    $("#srcbutton").hide();
    $("#ldngimgsrc").show();
    /*var api_urlpartial = adgurl + "V2/country/GB/partiallookup/vehicletype/3/manufacturer/" + srcmake + "/model/" + srcmodel;*/
    // var api_urlpartial = adgurl + "V2/country/GB/partiallookup/vehicletype/3/manufacturer/" + srcmake + "/model/" + srcmodel+'/matchcodesource/24';
    var api_urlpartial =
      adgurlNew +
      "api_id=72864&manufacturer=" +
      srcmake +
      "&model=" +
      srcmodel +
      "&ModelVersionID=" +
      srcmodelver +
      "&EngineCC=" +
      srcmodeleng +
      "&BodyStyleID=" +
      srcmodelbodystyles +
      "&DerivativeID=" +
      srcmodelderivatives +
      "&TransmissionTypeID=" +
      srcvtransmissiontype +
      "&FuelTypeID=" +
      srcvfueltype +
      "&ip=" +
      (getCookie("user_ip_tracking") || "0") +
      "&function_id=1830&vehicletypes=" +
      getCookie("vtype");
    $.ajax({
      url: api_urlpartial,
      type: "GET",
      success: function (result2) {
        var parsedObj = (typeof result2 === "string") ? JSON.parse(result2) : result2;
        //var parsedObj = result2;
        $("#vsrcresulthdf").html(parsedObj.gcodepartialids);
        pdataNewapi["PartialIDs"] = parsedObj.gcodepartialids;
        let pdataNewapi_PartialIDs = [];
        /*  all the partials ids */
        let gcodepartialid = [];
        let matchcodes = [];
        for (var eb = 0; eb < parsedObj.gcodepartialids.length; ++eb) {
          if (
            gcodepartialid.includes(
              parsedObj.gcodepartialids[eb].gcodepartialid
            ) == false
          ) {
            gcodepartialid.push(parsedObj.gcodepartialids[eb].gcodepartialid);
            pdataNewapi["PartialIDs"] =
              parsedObj.gcodepartialids[eb].gcodepartialid;
            pdataNewapi_PartialIDs.push(
              parsedObj.gcodepartialids[eb].gcodepartialid
            );
          }
          for (
            var mc = 0;
            mc < parsedObj.gcodepartialids[eb].matchcodes.length;
            ++mc
          ) {
            if (
              matchcodes.includes(
                parsedObj.gcodepartialids[eb].matchcodes[mc]
              ) == false
            ) {
              matchcodes.push(parsedObj.gcodepartialids[eb].matchcodes[mc]);
            }
          }
        }
        localStorage.ckksrcmake = srcmake;
        localStorage.ckksrcmodel = srcmodel;
        localStorage.ckksrcmodelver = srcmodelver;
        localStorage.ckksrcmodeleng = srcmodeleng;
        localStorage.ckksrcmodelbodystyles = srcmodelbodystyles;
        localStorage.ckksrcmodelderivatives = srcmodelderivatives;
        localStorage.ckksrfueltype = srcvfueltype;
        localStorage.ckksrtransmissiontype = srcvtransmissiontype;
        $("#vsrcresulthdf").text("");
        $.ajax({
          url:
            adgurlNew +
            "api_id=72854&partialIDs=" +
            pdataNewapi_PartialIDs.join(",") +
            "&ip=" +
            (getCookie("user_ip_tracking") || "0") +
            "&function_id=1874&vehicletypes=" +
            getCookie("vtype"),
          type: "POST",
          success: function (result3) {
            var parsedObj = (typeof result3 === "string") ? JSON.parse(result3) : result3;
            var v = 0;
            $("#vsrcresulthdf").text("");
            for (var i = 0; i < parsedObj.categories.length; ++i) {
              for (
                var j = 0;
                j < parsedObj.categories[i].subcategories.length;
                ++j
              ) {
                for (
                  var k = 0;
                  k <
                  parsedObj.categories[i].subcategories[j].components.length;
                  ++k
                ) {
                  for (
                    var p = 0;
                    p <
                    parsedObj.categories[i].subcategories[j].components[k].parts
                      .length;
                    ++p
                  ) {
                    vrmsrchsku.push(
                      parsedObj.categories[i].subcategories[j].components[k]
                        .parts[p].number
                    );
                    if (v == 0) {
                      v = 1;
                      $("#vsrcresulthdf").append(
                        "'" +
                          parsedObj.categories[i].subcategories[j].components[k]
                            .parts[p].number +
                          "'"
                      );
                    } else {
                      $("#vsrcresulthdf").append(
                        "+OR+'" +
                          parsedObj.categories[i].subcategories[j].components[k]
                            .parts[p].number +
                          "'"
                      );
                    }
                  }
                }
              }
            }
             /* adding new category start */
for (var a = 0; a < parsedObj.categories.length; ++a) {
	if(parsedObj.categories[a].subcategories.length==0 && parsedObj.categories[a].components.length > 0){
      
            for (var k = 0; k < parsedObj.categories[a].components.length; ++k) {
                for (var p = 0; p < parsedObj.categories[a].components[k].parts.length; ++p) {
				 if (v == 0) {
                      v = 1;
                      $("#vsrcresulthdf").append("'" +parsedObj.categories[a].components[k].parts[p].number +"'");
                  } else {
                      $("#vsrcresulthdf").append("+OR+'" +parsedObj.categories[a].components[k].parts[p].number +"'");
                  }
                  vrmsrchsku.push(parsedObj.categories[a].components[k].parts[p].number);
                }
                
			}
        }
    }
              /* adding new category end */	
            createCookie("vrmsrchsku", JSON.stringify(vrmsrchsku), 1 / 8);
            localStorage.ckksrcmake = srcmake;
            localStorage.ckksrcmodel = srcmodel;
            localStorage.ckksrcmodelver = srcmodelver;
            localStorage.ckksrcmodeleng = srcmodeleng;
            localStorage.ckksrcmodelbodystyles = srcmodelbodystyles;
            localStorage.ckksrcmodelderivatives = srcmodelderivatives;
            localStorage.ckksrfueltype = srcvfueltype;
            localStorage.ckksrtransmissiontype = srcvtransmissiontype;
            localStorage.setItem(
              "manualsrchurl",
              siteurls +
                "/pages/product-category?g=" +
                gcodepartialid.join("-") +
                "&t=" +
                matchcodes.join("-") +
                "&mk=" +
                srcmake +
                "&md=" +
                srcmodel +
                "&mdv=" +
                srcmodelver +
                "&eng=" +
                srcmodeleng +
                "&btyp=" +
                srcmodelbodystyles +
                "&der=" +
                srcmodelderivatives +
                "&fuel=" +
                srcvfueltype +
                "&trt=" +
                srcvtransmissiontype +
                ""
            );
            window.location.href =
              siteurls +
              "/pages/product-category?g=" +
              gcodepartialid.join("-") +
              "&t=" +
              matchcodes.join("-") +
              "&mk=" +
              srcmake +
              "&md=" +
              srcmodel +
              "&mdv=" +
              srcmodelver +
              "&eng=" +
              srcmodeleng +
              "&btyp=" +
              srcmodelbodystyles +
              "&der=" +
              srcmodelderivatives +
              "&fuel=" +
              srcvfueltype +
              "&trt=" +
              srcvtransmissiontype +
              "";
          },
          statusCode: {
            404: function () {
              alert("No record found");
            },
            400: function () {
              alert("No record found");
            },
            403: function () {
              alert("No record found");
            },
          },
        });
        /* show all the group and components end */
      },
      statusCode: {
        404: function (err) {
          alert("No record found");
        },
        400: function () {
          alert("No record found");
        },
        403: function () {
          alert("No record found");
        },
      },
    });
  }
}
/* get partial id for search end */
/* get product list baesd on components with partial id start */
function getlistoncomponentwithpartial(compid) {
  $("#vsrcresult").html(
    '<img  loading="lazy" src="https://cdn.shopify.com/s/files/1/0269/6327/9935/files/ajaxloader.gif?v=1596625858" />'
  );
  $("html, body").animate(
    {
      scrollTop: 150,
    },
    "slow"
  );
  $.ajax({
    // url: adgurl + "v2/country/gb/partials/component/" + compid + "/parts",
    url:
      adgurlNew +
      "api_id=72866&componentID=" +
      compid +
      "&partialids=" +
      pdata["partialids"] +
      "&ip=" +
      (getCookie("user_ip_tracking") || "0") +
      "&pageulr=" +
      window.location.href,
    type: "GET",
    contentType: "application/json",
    ataType: "json",
    success: function (result2) {
      $("#vsrcresulthdf").html("");
      var parsedObj = (typeof result2 === "string") ? JSON.parse(result2) : result2;
      var i;
      i = 0;
      for (var i = 0; i < parsedObj.parts.length; ++i) {
        if (i == 0) {
          $("#vsrcresulthdf").append("'" + parsedObj.parts[i].oenumber + "'");
        } else {
          $("#vsrcresulthdf").append(
            "+OR+'" + parsedObj.parts[i].oenumber + "'"
          );
        }
      }
      window.location.href =
        siteurls +
        "/search?type=product&q=variants.sku:" +
        $("#vsrcresulthdf").text() +
        "&view=sku&mk=" +
        mk +
        "&md=" +
        md +
        "&mdv=" +
        mdv +
        "&eng=" +
        eng +
        "&btyp=" +
        btyp +
        "&der=" +
        der +
        "&fuel=" +
        fuel +
        "&trt=" +
        trt +
        "";
    },
    statusCode: {
      404: function (err) {
        $("#vsrcresult").html("No record found");
      },
      400: function () {
        $("#vsrcresult").html("No record found");
      },
      403: function () {
        $("#vsrcresult").html("No record found");
      },
    },
  });
}
/* get product list baesd on components  with partial id end  */
/* get model based on make selection start */
function getmodelvalsrch(mk, md) {
  $("#vmodel").empty();
  $("#vmodel").append(new Option("Model", ""));
  var ckkvmodel;
  ckkvmodel = localStorage.ckkvmodel;
  if (ckkvmodel !== null && ckkvmodel != undefined && ckkvmodel != "") {
    var parsedObj = JSON.parse(ckkvmodel);
    for (var i = 0; i < parsedObj.models.length; ++i) {
      $("#vmodel").append(
        new Option(parsedObj.models[i].value, parsedObj.models[i].fieldid)
      );
    }
    $("#vmodel option[value=" + md + "]").prop("selected", "selected");
    $("#vmodel [value=" + md + "]").attr("selected", "true");
    $("#svModel").html($("#vmodel option[value=" + md + "]").text());
    if ($("#svModel1").length) {
      $("#svModel1").html($("#vmodel option[value=" + md + "]").text());
    }
  } else {
    var api_urlmodel =
      adgurlNew +
      "api_id=72870&manufacturer=" +
      mk +
      "&ip=" +
      (getCookie("user_ip_tracking") || "0") +
      "&pageulr=" +
      window.location.href +
      "&vehicletypes=" +
      getCookie("vtype");
    $.ajax({
      url: api_urlmodel,
      type: "GET",
      contentType: "application/json",
      ataType: "json",
      success: function (result2) {
        var parsedObj = (typeof result2 === "string") ? JSON.parse(result2) : result2;
        for (var i = 0; i < parsedObj.models.length; ++i) {
          $("#vmodel").append(
            new Option(parsedObj.models[i].value, parsedObj.models[i].fieldid)
          );
        }
        $("#vmodel option[value=" + md + "]").prop("selected", "selected");
        $("#vmodel [value=" + md + "]").attr("selected", "true");
      },
      statusCode: {
        404: function () {
          $("#vsrcresult").html("No record found");
        },
        400: function () {
          $("#vsrcresult").html("No record found");
        },
        403: function () {
          $("#vsrcresult").html("No record found");
        },
      },
    });
  }
}
/* get model based on make selection end */
/* get year based on make and model selection start */
function getyearvalsrch(mk, md, mdv) {
  $("#vmodelver").empty();
  $("#vmodelver").append(new Option("Model Version", ""));
  var ckkvmodelver;
  ckkvmodelver = localStorage.ckkvmodelver;
  if (
    ckkvmodelver !== null &&
    ckkvmodelver != undefined &&
    ckkvmodelver != ""
  ) {
    var parsedObj = JSON.parse(ckkvmodelver);
    for (var i = 0; i < parsedObj.length; ++i) {
      $("#vmodelver").append(
        new Option(parsedObj[i].value, parsedObj[i].fieldid)
      );
    }
    if (mdv != "") {
      $("#vmodelver option[value=" + mdv + "]").prop("selected", "selected");
      $("#vmodelver [value=" + mdv + "]").attr("selected", "true");
      $("#svYear").html($("#vmodelver option[value=" + mdv + "]").text());
      if ($("#svYear1").length) {
        $("#svYear1").html($("#vmodelver option[value=" + mdv + "]").text());
      }
    }
  } else {
    if (mdv != "") {
      var api_urlyear =
        adgurlNew +
        "api_id=72852&manufacturer=" +
        mk +
        "&model=" +
        md +
        "&ModelVersionID=" +
        mdv +
        "&ip=" +
        (getCookie("user_ip_tracking") || "0") +
        "&function_id=2080&vehicletypes=" +
        getCookie("vtype");

      $.ajax({
        url: api_urlyear,
        type: "GET",
        contentType: "application/json",
        ataType: "json",
        success: function (result2) {
          var parsedObj = result2;
          for (var i = 0; i < parsedObj.modelversions.length; ++i) {
            $("#vmodelver").append(
              new Option(
                parsedObj.modelversions[i].value,
                parsedObj.modelversions[i].fieldid
              )
            );
          }
          if (mdv != "") {
            $("#vmodelver option[value=" + mdv + "]").prop(
              "selected",
              "selected"
            );
            $("#vmodelver [value=" + mdv + "]").attr("selected", "true");
          }
        },
        statusCode: {
          404: function () {
            $("#vsrcresult").html("No record found");
          },
          400: function () {
            $("#vsrcresult").html("No record found");
          },
          403: function () {
            $("#vsrcresult").html("No record found");
          },
        },
      });
    } else {
      // var api_urlyear = adgurl+"V2/country/GB/partiallookup/vehicletype/3/manufacturer/" + mk + "/model/" + md + "";
      //var api_urlyear =adgurl+"V2/country/GB/partiallookup/vehicletype/3/manufacturer/173/model/4168";
      var api_urlyear =
        adgurlNew +
        "api_id=72852&manufacturer=" +
        mk +
        "&model=" +
        md +
        "&ip=" +
        (getCookie("user_ip_tracking") || "0") +
        "&function_id=2116&vehicletypes=" +
        getCookie("vtype");
      $.ajax({
        url: api_urlyear,
        type: "GET",
        contentType: "application/json",
        ataType: "json",
        success: function (result2) {
          var parsedObj = result2;
          for (var i = 0; i < parsedObj.modelversions.length; ++i) {
            $("#vmodelver").append(
              new Option(
                parsedObj.modelversions[i].value,
                parsedObj.modelversions[i].fieldid
              )
            );
          }
          if (mdv != "") {
            $("#vmodelver option[value=" + mdv + "]").prop(
              "selected",
              "selected"
            );
            $("#vmodelver [value=" + mdv + "]").attr("selected", "true");
          }
        },
        statusCode: {
          404: function () {
            $("#vsrcresult").html("No record found");
          },
          400: function () {
            $("#vsrcresult").html("No record found");
          },
          403: function () {
            $("#vsrcresult").html("No record found");
          },
        },
      });
    }
  }
}
/* get year based on make and model  selection end */
/* get Engine based on make and model selection start */
function getenginevalsrch(mk, md, mdv, eng) {
  $("#vmodeleng").empty();
  $("#vmodeleng").append(new Option("Engine CC", ""));
  var ckkvmodeleng;
  ckkvmodeleng = localStorage.ckkvmodeleng;
  if (
    ckkvmodeleng !== null &&
    ckkvmodeleng != undefined &&
    ckkvmodeleng != ""
  ) {
    var parsedObj = JSON.parse(ckkvmodeleng);
    for (var i = 0; i < parsedObj.length; ++i) {
      $("#vmodeleng").append(
        new Option(parsedObj[i].value, parsedObj[i].fieldid)
      );
    }
    if (eng != "") {
      $("#vmodeleng option[value=" + eng + "]").prop("selected", "selected");
      $("#vmodeleng [value=" + eng + "]").attr("selected", "true");
      $("#svEngine").html(
        $("#vmodeleng option[value=" + eng + "]").text() + "cc"
      );
      if ($("#svEngine1").length) {
        $("#svEngine1").html(
          $("#vmodeleng option[value=" + eng + "]").text() + "cc"
        );
      }
    }
  } else {
    if (mdv != "") {
      // var api_urlyear = adgurl+"V2/country/GB/partiallookup/vehicletype/3/manufacturer/" + mk + "/model/" + md + "";
      var api_urlyear =
        adgurlNew +
        "api_id=72852&manufacturer=" +
        mk +
        "&model=" +
        md +
        "&ModelVersionID=" +
        mdv +
        "&ip=" +
        (getCookie("user_ip_tracking") || "0") +
        "&function_id=2180&vehicletypes=" +
        getCookie("vtype");
      $.ajax({
        url: api_urlyear,
        type: "GET",
        contentType: "application/json",
        ataType: "json",
        success: function (result2) {
          var parsedObj = result2;
          for (var i = 0; i < parsedObj.engineccs.length; ++i) {
            $("#vmodeleng").append(
              new Option(
                parsedObj.engineccs[i].value,
                parsedObj.engineccs[i].fieldid
              )
            );
          }
          if (eng != "") {
            $("#vmodeleng option[value=" + mdv + "]").prop(
              "selected",
              "selected"
            );
            $("#vmodeleng [value=" + mdv + "]").attr("selected", "true");
          }
        },
        statusCode: {
          404: function () {
            $("#vsrcresult").html("No record found");
          },
          400: function () {
            $("#vsrcresult").html("No record found");
          },
          403: function () {
            $("#vsrcresult").html("No record found");
          },
        },
      });
    } else {
      // var api_urlyear = adgurl+"V2/country/GB/partiallookup/vehicletype/3/manufacturer/" + mk + "/model/" + md + "";
      var api_urlyear =
        adgurlNew +
        "api_id=72852&manufacturer=" +
        mk +
        "&model=" +
        md +
        "&ip=" +
        (getCookie("user_ip_tracking") || "0") +
        "&function_id=2214&vehicletypes=" +
        getCookie("vtype");
      //var api_urlyear =adgurl+"V2/country/GB/partiallookup/vehicletype/3/manufacturer/173/model/4168";
      $.ajax({
        url: api_urlyear,
        type: "GET",
        contentType: "application/json",
        ataType: "json",
        success: function (result2) {
          var parsedObj = result2;
          for (var i = 0; i < parsedObj.engineccs.length; ++i) {
            $("#vmodeleng").append(
              new Option(
                parsedObj.engineccs[i].value,
                parsedObj.engineccs[i].fieldid
              )
            );
          }
          if (eng != "") {
            $("#vmodeleng option[value=" + mdv + "]").prop(
              "selected",
              "selected"
            );
            $("#vmodeleng [value=" + mdv + "]").attr("selected", "true");
          }
        },
        statusCode: {
          404: function () {
            $("#vsrcresult").html("No record found");
          },
          400: function () {
            $("#vsrcresult").html("No record found");
          },
          403: function () {
            $("#vsrcresult").html("No record found");
          },
        },
      });
    }
  }
}
/* get Engine based on make and model  selection end */
/* get body style based on make and model selection start */
function getbodystylesvalsrch(mk, md, mdv, eng, btyp) {
  $("#vmodelbodystyles").empty();
  $("#vmodelbodystyles").append(new Option("Body Styles", ""));
  var ckkvmodelbodystyles;
  ckkvmodelbodystyles =
    localStorage.ckkvmodelbodystyles;
  if (
    ckkvmodelbodystyles !== null &&
    ckkvmodelbodystyles != undefined &&
    ckkvmodelbodystyles != ""
  ) {
    var parsedObj = JSON.parse(ckkvmodelbodystyles);
    for (var i = 0; i < parsedObj.length; ++i) {
      $("#vmodelbodystyles").append(
        new Option(parsedObj[i].value, parsedObj[i].fieldid)
      );
    }
    if (btyp != "") {
      $("#vmodelbodystyles option[value=" + btyp + "]").prop(
        "selected",
        "selected"
      );
      $("#vmodelbodystyles [value=" + btyp + "]").attr("selected", "true");
      $("#svBodystyle").html(
        $("#vmodelbodystyles option[value=" + btyp + "]").text()
      );
      if ($("#svBodystyle1").length) {
        $("#svBodystyle1").html(
          $("#vmodelbodystyles option[value=" + btyp + "]").text()
        );
      }
    }
  } else {
    if (mdv != "") {
      // var api_urlyear = adgurl+"V2/country/GB/partiallookup/vehicletype/3/manufacturer/" + mk + "/model/" + md + "";
      var api_urlyear =
        adgurlNew +
        "api_id=72852&manufacturer=" +
        mk +
        "&model=" +
        md +
        "&ModelVersionID=" +
        mdv +
        "&ip=" +
        (getCookie("user_ip_tracking") || "0") +
        "&function_id=2280&vehicletypes=" +
        getCookie("vtype");
      $.ajax({
        url: api_urlyear,
        type: "GET",
        contentType: "application/json",
        ataType: "json",
        success: function (result2) {
          var parsedObj = result2;
          for (var i = 0; i < parsedObj.bodystyles.length; ++i) {
            $("#vmodelbodystyles").append(
              new Option(
                parsedObj.bodystyles[i].value,
                parsedObj.bodystyles[i].fieldid
              )
            );
          }
          if (btyp != "") {
            $("#vmodelbodystyles option[value=" + btyp + "]").prop(
              "selected",
              "selected"
            );
            $("#vmodelbodystyles [value=" + btyp + "]").attr(
              "selected",
              "true"
            );
          }
        },
        statusCode: {
          404: function () {
            $("#vsrcresult").html("No record found");
          },
          400: function () {
            $("#vsrcresult").html("No record found");
          },
          403: function () {
            $("#vsrcresult").html("No record found");
          },
        },
      });
    } else {
      // var api_urlyear = adgurl+"V2/country/GB/partiallookup/vehicletype/3/manufacturer/" + mk + "/model/" + md + "";
      var api_urlyear =
        adgurlNew +
        "api_id=72852&manufacturer=" +
        mk +
        "&model=" +
        md +
        "&ip=" +
        (getCookie("user_ip_tracking") || "0") +
        "&function_id=2314&vehicletypes=" +
        getCookie("vtype");
      //var api_urlyear =adgurl+"V2/country/GB/partiallookup/vehicletype/3/manufacturer/173/model/4168";
      $.ajax({
        url: api_urlyear,
        type: "GET",
        contentType: "application/json",
        ataType: "json",
        success: function (result2) {
          var parsedObj = result2;
          for (var i = 0; i < parsedObj.bodystyles.length; ++i) {
            $("#vmodelbodystyles").append(
              new Option(
                parsedObj.bodystyles[i].value,
                parsedObj.bodystyles[i].fieldid
              )
            );
          }
          if (btyp != "") {
            $("#vmodelbodystyles option[value=" + btyp + "]").prop(
              "selected",
              "selected"
            );
            $("#vmodelbodystyles [value=" + btyp + "]").attr(
              "selected",
              "true"
            );
          }
        },
        statusCode: {
          404: function () {
            $("#vsrcresult").html("No record found");
          },
          400: function () {
            $("#vsrcresult").html("No record found");
          },
          403: function () {
            $("#vsrcresult").html("No record found");
          },
        },
      });
    }
  }
}
/* get body style based on make and model  selection end */
/* get Derivatives based on make and model selection start */
function getderivativesvalsrch(mk, md, mdv, eng, btyp, der) {
  $("#vmodelderivatives").empty();
  $("#vmodelderivatives").append(new Option("Derivatives", ""));
  var ckkvmodelderivatives;
  ckkvmodelderivatives =
    localStorage.ckkvmodelderivatives;
  if (
    ckkvmodelderivatives !== null &&
    ckkvmodelderivatives != undefined &&
    ckkvmodelderivatives != ""
  ) {
    var parsedObj = JSON.parse(ckkvmodelderivatives);
    for (var i = 0; i < parsedObj.length; ++i) {
      $("#vmodelderivatives").append(
        new Option(parsedObj[i].value, parsedObj[i].fieldid)
      );
    }
    if (der != "") {
      $("#vmodelderivatives option[value=" + der + "]").prop(
        "selected",
        "selected"
      );
      $("#vmodelderivatives [value=" + der + "]").attr("selected", "true");
      $("#svderivative").html(
        $("#vmodelderivatives option[value=" + der + "]").text()
      );
      if ($("#svderivative1").length) {
        $("#svderivative1").html(
          $("#vmodelderivatives option[value=" + der + "]").text()
        );
      }
    }
  } else {
    if (mdv != "") {
      // var api_urlyear = adgurl+"V2/country/GB/partiallookup/vehicletype/3/manufacturer/" + mk + "/model/" + md + "";
      var api_urlyear =
        adgurlNew +
        "api_id=72852&manufacturer=" +
        mk +
        "&model=" +
        md +
        "&ModelVersionID=" +
        mdv +
        "&ip=" +
        (getCookie("user_ip_tracking") || "0") +
        "&function_id=2380&vehicletypes=" +
        getCookie("vtype");
      $.ajax({
        url: api_urlyear,
        type: "GET",
        contentType: "application/json",
        ataType: "json",
        success: function (result2) {
          var parsedObj = result2;
          for (var i = 0; i < parsedObj.bodystyles.length; ++i) {
            $("#vmodelderivatives").append(
              new Option(
                parsedObj.bodystyles[i].value,
                parsedObj.bodystyles[i].fieldid
              )
            );
          }
          if (der != "") {
            $("#vmodelderivatives option[value=" + der + "]").prop(
              "selected",
              "selected"
            );
            $("#vmodelderivatives [value=" + der + "]").attr(
              "selected",
              "true"
            );
          }
        },
        statusCode: {
          404: function () {
            $("#vsrcresult").html("No record found");
          },
          400: function () {
            $("#vsrcresult").html("No record found");
          },
          403: function () {
            $("#vsrcresult").html("No record found");
          },
        },
      });
    } else {
      //var api_urlyear = adgurl+"V2/country/GB/partiallookup/vehicletype/3/manufacturer/" + mk + "/model/" + md + "";
      var api_urlyear =
        adgurlNew +
        "api_id=72852&manufacturer=" +
        mk +
        "&model=" +
        md +
        "&ip=" +
        (getCookie("user_ip_tracking") || "0") +
        "&function_id=2410&vehicletypes=" +
        getCookie("vtype");
      //var api_urlyear =adgurl+"V2/country/GB/partiallookup/vehicletype/3/manufacturer/173/model/4168";
      $.ajax({
        url: api_urlyear,
        type: "POST",
        contentType: "application/json",
        dataType: "json",
        success: function (result2) {
          var parsedObj = result2;
          for (var i = 0; i < parsedObj.bodystyles.length; ++i) {
            $("#vmodelderivatives").append(
              new Option(
                parsedObj.bodystyles[i].value,
                parsedObj.bodystyles[i].fieldid
              )
            );
          }
          if (der != "") {
            $("#vmodelderivatives option[value=" + der + "]").prop(
              "selected",
              "selected"
            );
            $("#vmodelderivatives [value=" + der + "]").attr(
              "selected",
              "true"
            );
          }
        },
        statusCode: {
          404: function () {
            $("#vsrcresult").html("No record found");
          },
          400: function () {
            $("#vsrcresult").html("No record found");
          },
          403: function () {
            $("#vsrcresult").html("No record found");
          },
        },
      });
    }
  }
}
/* get Derivatives based on make and model  selection end */
/* get fuel based on make and model selection start */
function getfueltypevalsrch(mk, md, mdv, eng, btyp, der, fuel) {
  $("#vfueltype").empty();
  $("#vfueltype").append(new Option("Fuel Type", ""));
  var ckkvfueltype;
  ckkvfueltype = localStorage.ckkvfueltype;
  if (
    ckkvfueltype !== null &&
    ckkvfueltype != undefined &&
    ckkvfueltype != ""
  ) {
    var parsedObj = JSON.parse(ckkvfueltype);
    for (var i = 0; i < parsedObj.length; ++i) {
      $("#vfueltype").append(
        new Option(parsedObj[i].value, parsedObj[i].fieldid)
      );
    }
    if (fuel != "") {
      $("#vfueltype option[value=" + fuel + "]").prop("selected", "selected");
      $("#vfueltype [value=" + fuel + "]").attr("selected", "true");
      $("#svFuel").html($("#vfueltype option[value=" + fuel + "]").text());
      if ($("#svFuel1").length) {
        $("#svFuel1").html($("#vfueltype option[value=" + fuel + "]").text());
      }
    }
  } else {
    if (mdv != "") {
      // var api_urlyear = adgurl+"V2/country/GB/partiallookup/vehicletype/3/manufacturer/" + mk + "/model/" + md + "";
      var api_urlyear =
        adgurlNew +
        "api_id=72852&manufacturer=" +
        mk +
        "&model=" +
        md +
        "&ModelVersionID=" +
        mdv +
        "&ip=" +
        (getCookie("user_ip_tracking") || "0") +
        "&function_id=2481&vehicletypes=" +
        getCookie("vtype");
      $.ajax({
        url: api_urlyear,
        type: "GET",
        contentType: "application/json",
        ataType: "json",
        success: function (result2) {
          var parsedObj = result2;
          for (var i = 0; i < parsedObj.bodystyles.length; ++i) {
            $("#vfueltype").append(
              new Option(
                parsedObj.bodystyles[i].value,
                parsedObj.bodystyles[i].fieldid
              )
            );
          }
          if (fuel != "") {
            $("#vfueltype option[value=" + fuel + "]").prop(
              "selected",
              "selected"
            );
            $("#vfueltype [value=" + fuel + "]").attr("selected", "true");
          }
        },
        statusCode: {
          404: function () {
            $("#vsrcresult").html("No record found");
          },
          400: function () {
            $("#vsrcresult").html("No record found");
          },
          403: function () {
            $("#vsrcresult").html("No record found");
          },
        },
      });
    } else {
      //var api_urlyear = adgurl+"V2/country/GB/partiallookup/vehicletype/3/manufacturer/" + mk + "/model/" + md + "";
      var api_urlyear =
        adgurlNew +
        "api_id=72852&manufacturer=" +
        mk +
        "&model=" +
        md +
        "&ip=" +
        (getCookie("user_ip_tracking") || "0") +
        "&function_id=2515&vehicletypes=" +
        getCookie("vtype");
      $.ajax({
        url: api_urlyear,
        type: "GET",
        contentType: "application/json",
        ataType: "json",
        success: function (result2) {
          var parsedObj = result2;
          for (var i = 0; i < parsedObj.fueltypes.length; ++i) {
            $("#vfueltype").append(
              new Option(
                parsedObj.fueltypes[i].value,
                parsedObj.fueltypes[i].fieldid
              )
            );
          }
          if (fuel != "") {
            $("#vfueltype option[value=" + fuel + "]").prop(
              "selected",
              "selected"
            );
            $("#vfueltype [value=" + fuel + "]").attr("selected", "true");
          }
        },
        statusCode: {
          404: function () {
            $("#vsrcresult").html("No record found");
          },
          400: function () {
            $("#vsrcresult").html("No record found");
          },
          403: function () {
            $("#vsrcresult").html("No record found");
          },
        },
      });
    }
  }
}
/* get fuel based on make and model  selection end */
/* get gettransmissiontype based on make and model selection start */
function gettransmissiontypevalsrch(mk, md, mdv, eng, btyp, der, fuel, trt) {
  $("#vtransmissiontype").empty();
  $("#vtransmissiontype").append(new Option("Transmission Type", ""));
  var ckksrtransmissiontype;
  ckksrtransmissiontype = getCookie("ckkvtransmissiontype");
  if (
    ckksrtransmissiontype !== null &&
    ckksrtransmissiontype != undefined &&
    ckksrtransmissiontype != ""
  ) {
    var parsedObj = JSON.parse(ckksrtransmissiontype);
    for (var i = 0; i < parsedObj.length; ++i) {
      $("#vtransmissiontype").append(
        new Option(parsedObj[i].value, parsedObj[i].fieldid)
      );
    }
    if (trt != "") {
      $("#vtransmissiontype option[value=" + trt + "]").prop(
        "selected",
        "selected"
      );
      $("#vtransmissiontype [value=" + trt + "]").attr("selected", "true");
    }
  } else {
    if (mdv != "") {
      // var api_urlyear = adgurl+"V2/country/GB/partiallookup/vehicletype/3/manufacturer/" + mk + "/model/" + md + "";
      var api_urlyear =
        adgurlNew +
        "api_id=72852&manufacturer=" +
        mk +
        "&model=" +
        md +
        "&ModelVersionID=" +
        mdv +
        "&ip=" +
        (getCookie("user_ip_tracking") || "0") +
        "&function_id=2575&vehicletypes=" +
        getCookie("vtype");
      $.ajax({
        url: api_urlyear,
        type: "GET",
        contentType: "application/json",
        ataType: "json",
        success: function (result2) {
          var parsedObj = result2;
          for (var i = 0; i < parsedObj.bodystyles.length; ++i) {
            $("#vtransmissiontype").append(
              new Option(
                parsedObj.bodystyles[i].value,
                parsedObj.bodystyles[i].fieldid
              )
            );
          }
          if (trt != "") {
            $("#vtransmissiontype option[value=" + trt + "]").prop(
              "selected",
              "selected"
            );
            $("#vtransmissiontype [value=" + trt + "]").attr(
              "selected",
              "true"
            );
          }
        },
        statusCode: {
          404: function () {
            $("#vsrcresult").html("No record found");
          },
          400: function () {
            $("#vsrcresult").html("No record found");
          },
          403: function () {
            $("#vsrcresult").html("No record found");
          },
        },
      });
    } else {
      // var api_urlyear = adgurl+"V2/country/GB/partiallookup/vehicletype/3/manufacturer/" + mk + "/model/" + md + "";
      var api_urlyear =
        adgurlNew +
        "api_id=72852&manufacturer=" +
        mk +
        "&model=" +
        md +
        "&ip=" +
        (getCookie("user_ip_tracking") || "0") +
        "&function_id=2609&vehicletypes=" +
        getCookie("vtype");
      $.ajax({
        url: api_urlyear,
        type: "POST",
        contentType: "application/json",
        dataType: "json",
        success: function (result2) {
          var parsedObj = result2;
          for (var i = 0; i < parsedObj.fueltypes.length; ++i) {
            $("#vtransmissiontype").append(
              new Option(
                parsedObj.fueltypes[i].value,
                parsedObj.fueltypes[i].fieldid
              )
            );
          }
          if (trt != "") {
            $("#vtransmissiontype option[value=" + trt + "]").prop(
              "selected",
              "selected"
            );
            $("#vtransmissiontype [value=" + trt + "]").attr(
              "selected",
              "true"
            );
          }
        },
        statusCode: {
          404: function () {
            $("#vsrcresult").html("No record found");
          },
          400: function () {
            $("#vsrcresult").html("No record found");
          },
          403: function () {
            $("#vsrcresult").html("No record found");
          },
        },
      });
    }
  }
}
/* get gettransmissiontype based on make and model  selection end */
/* get patrial id based on vrm start */
function getlistoncomponentwithpartialVRM(compid, value) {
  $("#vsrcresult").html(
    '<img  loading="lazy" src="https://cdn.shopify.com/s/files/1/0269/6327/9935/files/ajaxloader.gif?v=1596625858" />'
  );
  $("html, body").animate(
    {
      scrollTop: 150,
    },
    "slow"
  );
  $.ajax({
    // url: adgurl + "V2/country/GB/vehicle/"+value+"/component/"+compid+"/parts",
    url:
      adgurlNew +
      "api_id=72868&vrm=" +
      value +
      "&componentID=" +
      compid +
      "&ip=" +
      (getCookie("user_ip_tracking") || "0") +
      "&pageulr=" +
      window.location.href,
    type: "GET",
    contentType: "application/json",
    ataType: "json",
    success: function (result3) {
      $("#vsrcresulthdf").html("");
      var parsedObj = (typeof result3 === "string") ? JSON.parse(result3) : result3;
      for (var i = 0; i < parsedObj.parts.length; ++i) {
        if (i == 0) {
          $("#vsrcresulthdf").append(
            "'" + parsedObj.parts[i][0].oenumber + "'"
          );
        } else {
          $("#vsrcresulthdf").append(
            "+OR+'" + parsedObj.parts[i][0].oenumber + "'"
          );
        }
      }
      window.location.href =
        siteurls +
        "/search?type=product&q=variants.sku:" +
        $("#vsrcresulthdf").text() +
        "&view=sku&autog=" +
        value;
    },
    statusCode: {
      404: function () {
        $("#vsrcresult").html('<hr aria-hidden="true">No record found');
      },
      400: function () {
        $("#vsrcresult").html('<hr aria-hidden="true">No record found');
      },
      403: function () {
        $("#vsrcresult").html('<hr aria-hidden="true">No record found');
      },
    },
  });
}
/* get patrial id based on vrm end */
function createCookie(name, value, cdays) {
  if (typeof cdays === "undefined" || cdays === null) cdays = 30;
   var expires = "";  
  if (cdays) {
    var date = new Date();
    date.setTime(date.getTime() + (cdays * 24 * 60 * 60 * 1000));
    var expires = "; expires=" + date.toGMTString();
  }
  document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
  var cookieArr = document.cookie.split(";");

  for (var i = 0; i < cookieArr.length; i++) {
    var cookiePair = cookieArr[i].split("=");
    if (name == cookiePair[0].trim()) {
      return decodeURIComponent(cookiePair[1]);
    }
  }
  return null;
}
/* product detail page check fit part or not */
$(document).ready(function () {
  $("#buttonfit").click(function (event) {
    var vihclenumber = "";
    var pcodedetail = "";
    var is_found = 0;
    $("#buttonfit").hide();
    $("#ldngimg").show();
    var vihclenumberfit = $("#vihclenumberfit").val();
    if (!vihclenumberfit) { $("#buttonfit").show(); $("#ldngimg").hide(); return false; }
    vihclenumberfit = vihclenumberfit.replace(/\s/g, "").trim();
    pcodedetail = $("#pcodedetail").html();
    if (!pcodedetail) { $("#buttonfit").show(); $("#ldngimg").hide(); return false; }
    pcodedetail = pcodedetail.replace(/\s/g, "").trim();
    if (vihclenumberfit == "" || vihclenumberfit == "YOURREG") {
      $("#buttonfit").show();
      $("#ldngimg").hide();
      /* Silent exit on programmatic triggers (e.g. the fitment auto-check in
         layout/theme.liquid) — no user interaction, so no alert. */
      if (event && event.isTrigger) { return false; }
      alert("Please enter vehicle number");
      return false;
    } else {
      $.ajax({
        //url: adgurl + "v1/vrm/"+vihclenumberfit+"/partnumbers",
        url:
          adgurlNew +
          "api_id=72841&vrm=" +
          vihclenumberfit +
          "&ip=" +
          (getCookie("user_ip_tracking") || "0") +
          "&function_id=buttonfit2731",
        type: "GET",
        success: function (result3) {
          var parsedObj = (typeof result3 === "string") ? JSON.parse(result3) : result3;
          let skucnt;
          skucnt = 0;
          for (var v = 0; v < parsedObj.categories.length; ++v) {
            for (
              var i = 0;
              i < parsedObj.categories[v].subcategories.length;
              ++i
            ) {
              for (
                var j = 0;
                j < parsedObj.categories[v].subcategories[i].components.length;
                ++j
              ) {
                for (
                  var k = 0;
                  k <
                  parsedObj.categories[v].subcategories[i].components[j].parts
                    .length;
                  ++k
                ) {
                  if (
                    parsedObj.categories[v].subcategories[i].components[j]
                      .parts[k].number == pcodedetail.toUpperCase()
                  ) {
                    $("#buttonfit").show();
                    $("#ldngimg").hide();
                    is_found = 1;
                    $("#checkfitment").hide();
                    $("#checkfitsuc").show();
                    /* $(".checkfitsuc-alt").show(); */
                    $("#checkfitfail").hide();
                    $(".checkfitfail-alt").hide();
                    /*alert('This Part Is Fit In '+vihclenumberfit.toUpperCase());*/
                    break;
                  }
                  skucnt++;
                  if (skucnt < 50) {
                    if (is_found == 0) {
                      skulist =
                        parsedObj.categories[v].subcategories[i].components[j]
                          .parts[k].number;
                    } else {
                      skulist =
                        skulist +
                        "+OR+" +
                        parsedObj.categories[v].subcategories[i].components[j]
                          .parts[k].number;
                    }
                    vrmsrchsku.push(
                      parsedObj.categories[v].subcategories[i].components[j]
                        .parts[k].number
                    );
                  }
                }
              }
            }
          }
          /* adding new category start */
/*for (var v = 0; v < parsedObj.categories.length; ++v) {
	if(parsedObj.categories[v].subcategories.length==0 && parsedObj.categories[v].components.length > 0){
            for (var k = 0; k < parsedObj.categories[v].components.length; ++k) {
                for (var p = 0; p < parsedObj.categories[v].components[k].parts.length; ++p) {
				skucnt++;
                if (skucnt < 50) {
                  if (is_found == 0) {
                    skulist =
                      parsedObj.categories[v].subcategories[v].components[k]
                        .parts[k].number;
                  } else {
                    skulist =
                      skulist +
                      "+OR+" +
                      parsedObj.categories[v].subcategories[v].components[k]
                        .parts[k].number;
                  }
                  vrmsrchsku.push(
                    parsedObj.categories[v].subcategories[v].components[k]
                      .parts[k].number
                  );
                }
                is_found = 1;
                }
                
			}
        }
    }*/
              /* adding new category end */	
          if (parsedObj.categories.length > 0) {
            createCookie("vihclenumberfit", vihclenumberfit, 1 / 12);
            createCookie("ckkautog", vihclenumberfit, 1);
            createCookie(
              "vrmsrchskufitment",
              JSON.stringify(vrmsrchsku),
              1 / 8
            );
            $("#breadcrumbvrm").attr("data-target", "");
          }
          sessionStorage.setItem("tvp_reg", vihclenumberfit);
          if (is_found == 0) {
            $("#buttonfit").show();
            $("#ldngimg").hide();
            $("#checkfitment").hide();
            $("#checkfitfail").show();
            /* $(".checkfitfail-alt").show(); */
          } else {
            $("#checkfitment").hide();
            if ($("#product_Tyre_is").val() == 1) {
              modal23.style.display = "block";
              $("#checkfitsuc_11").hide();
              $(".checkfitsuc_11").hide();
              $("#checkfitsuc_22").hide();
              $(".checkfitsuc_22").hide();
              $("#checkfitsuc_33").show();
              $(".checkfitsuc_33").show();
              $("#checkfitsuc_33").css("display", "initial");
              $(".checkfitsuc_33").css("display", "initial");
            } else {
              $("#checkfitsuc_11").show();
              $(".checkfitsuc_11").show();
              $("#checkfitsuc_22").show();
              $(".checkfitsuc_22").show();
              $("#checkfitsuc_33").hide();
              $(".checkfitsuc_33").hide();
            }
          }
          if (parsedObj.categories.length == 0 && is_found == 0) {
            alert(
              "No vehicle found for this reg number, please check the number and try again."
            );
            $("#buttonfit").show();
            $("#ldngimg").hide();
            $("#checkfitment").show();
            $("#checkfitsuc").hide();
            $(".checkfitsuc-alt").hide();
            $("#checkfitfail").hide();
            $(".checkfitfail-alt").hide();
            localStorage.setItem("vihclenumberfit", "");
            localStorage.vihclenumberfit = "";
            createCookie("vihclenumberfit", "", -1);
          }
        },
        statusCode: {
          404: function () {
            $("#buttonfit").show();
            $("#ldngimg").hide();
            $("#checkfitment").hide();
            $("#checkfitsuc").hide();
            $(".checkfitsuc-alt").hide();
            $("#checkfitfail").show();
            /* $(".checkfitfail-alt").show(); */
          },
          400: function () {
            $("#buttonfit").show();
            $("#ldngimg").hide();
            $("#checkfitment").hide();
            $("#checkfitsuc").hide();
            $(".checkfitsuc-alt").hide();
            $("#checkfitfail").show();
            /* $(".checkfitfail-alt").show(); */
          },
          403: function () {
            $("#buttonfit").show();
            $("#ldngimg").hide();
            $("#checkfitment").hide();
            $("#checkfitsuc").hide();
            $(".checkfitsuc-alt").hide();
            $("#checkfitfail").show();
            /* $(".checkfitfail-alt").show(); */
          },
        },
      });
    }
  });
});
function buttonfit() {
  var vihclenumber = "";
  var pcodedetail = "";
  var is_found = 0;
  $("#buttonfit").hide();
  $("#ldngimg").show();
  vihclenumberfit = $("#vihclenumberfit").val();
  vihclenumberfit = vihclenumberfit.replace(/\s/g, "");
  vihclenumberfit.trim();
  pcodedetail = $("#pcodedetail").html();
  pcodedetail = pcodedetail.replace(/\s/g, "");
  pcodedetail.trim();
  if (vihclenumberfit == "" || vihclenumberfit == "YOURREG") {
    $("#buttonfit").show();
    $("#ldngimg").hide();
    alert("Please enter vehicle number");
    return false;
  } else {
    $.ajax({
      //url: adgurl + "v1/vrm/"+vihclenumberfit+"/partnumbers",
      url:
        adgurlNew +
        "api_id=72841&vrm=" +
        vihclenumberfit +
        "&ip=" +
        (getCookie("user_ip_tracking") || "0") +
        "&function_id=buttonfit2816",
      type: "GET",
      success: function (result3) {
        var parsedObj = (typeof result3 === "string") ? JSON.parse(result3) : result3;
        let skucnt;
        skucnt = 0;
        for (var v = 0; v < parsedObj.categories.length; ++v) {
          for (
            var i = 0;
            i < parsedObj.categories[v].subcategories.length;
            ++i
          ) {
            for (
              var j = 0;
              j < parsedObj.categories[v].subcategories[i].components.length;
              ++j
            ) {
              for (
                var k = 0;
                k <
                parsedObj.categories[v].subcategories[i].components[j].parts
                  .length;
                ++k
              ) {
                if (
                  parsedObj.categories[v].subcategories[i].components[j].parts[
                    k
                  ].number == pcodedetail.toUpperCase()
                ) {
                  $("#buttonfit").show();
                  $("#ldngimg").hide();
                  is_found = 1;
                  $("#checkfitment").hide();
                  $("#checkfitsuc").show();
                  $("#checkfitfail").hide();
                  break;
                }
                skucnt++;
                if (skucnt < 50) {
                  if (is_found == 0) {
                    skulist =
                      parsedObj.categories[v].subcategories[i].components[j]
                        .parts[k].number;
                  } else {
                    skulist =
                      skulist +
                      "+OR+" +
                      parsedObj.categories[v].subcategories[i].components[j]
                        .parts[k].number;
                  }
                  vrmsrchsku.push(
                    parsedObj.categories[v].subcategories[i].components[j]
                      .parts[k].number
                  );
                }
              }
            }
          }
        }
        if (is_found == 0) {
          $("#buttonfit").show();
          $("#ldngimg").hide();
          $("#checkfitment").hide();
          $("#checkfitsuc").hide();
          $("#checkfitfail").show();
        }
      },
      statusCode: {
        404: function () {
          $("#buttonfit").show();
          $("#ldngimg").hide();
          $("#checkfitment").hide();
          $("#checkfitsuc").hide();
          $("#checkfitfail").show();
        },
        400: function () {
          $("#buttonfit").show();
          $("#ldngimg").hide();
          $("#checkfitment").hide();
          $("#checkfitsuc").hide();
          $("#checkfitfail").show();
        },
        403: function () {
          $("#buttonfit").show();
          $("#ldngimg").hide();
          $("#checkfitment").hide();
          $("#checkfitsuc").hide();
          $("#checkfitfail").show();
        },
      },
    });
  }
}
function showfitment() {
  $("#buttonfit").show();
  $("#ldngimg").hide();
  $("#checkfitment").show();
  $("#checkfitsuc").hide();
  $(".checkfitsuc-alt").hide();
  $("#checkfitfail").hide();
  $(".checkfitfail-alt").hide();
}
function findmorfitment() {
  var is_found = 0;
  var skulist = "";
  if (localStorage.getItem("manualsrchurl") != "") {
    window.location.replace(localStorage.getItem("manualsrchurl"));
  } else if (localStorage.getItem("vrmsrchurl") != "") {
    window.location.replace(localStorage.getItem("vrmsrchurl"));
  } else {
    $.ajax({
      //url: adgurl + "v1/vrm/"+$("#vihclenumberfit").val()+"/partnumbers",
      url:
        adgurlNew +
        "api_id=72841&vrm=" +
        $("#vihclenumberfit").val() +
        "&ip=" +
        (getCookie("user_ip_tracking") || "0") +
        "&function_id=findmorfitment",
      type: "GET",
      success: function (result3) {
        var parsedObj = (typeof result3 === "string") ? JSON.parse(result3) : result3;
        var vlen = parsedObj.categories.length;
        for (var v = 0; v < vlen; ++v) {
          var ilen = parsedObj.categories[v].subcategories.length;
          for (var i = 0; i < ilen; ++i) {
            var jlen =
              parsedObj.categories[v].subcategories[i].components.length;
            for (var j = 0; j < jlen; ++j) {
              var klen =
                parsedObj.categories[v].subcategories[i].components[j].parts
                  .length;
              for (var k = 0; k < klen; ++k) {
                if (is_found == 0) {
                  skulist =
                    parsedObj.categories[v].subcategories[i].components[j]
                      .parts[k].number;
                } else {
                  skulist =
                    skulist +
                    "+OR+" +
                    parsedObj.categories[v].subcategories[i].components[j]
                      .parts[k].number;
                }
                is_found = 1;
              }
            }
          }
        }

        if (is_found == 1) {
          window.location.replace(
            siteurls +
              "/search?type=product&q=variants.sku:" +
              skulist +
              "&view=sku&autog=" +
              $("#vihclenumberfit").val()
          );
        } else {
          window.location.replace(
            siteurls + "/search?autog=" + $("#vihclenumberfit").val()
          );
        }
      },
      statusCode: {
        404: function () {
          window.location.replace(
            siteurls + "/search?autog=" + $("#vihclenumberfit").val()
          );
        },
        400: function () {
          window.location.replace(
            siteurls + "/search?autog=" + $("#vihclenumberfit").val()
          );
        },
        403: function () {
          window.location.replace(
            siteurls + "/search?autog=" + $("#vihclenumberfit").val()
          );
        },
      },
    });
  }
}
$(document).ready(function () {
  tvp_ip_tracking_if_consented(4);
});
function othervehfit(sku) {
  /*$.getJSON("https://jsonip.com/?callback=", function (n) {
    var p = window.JSON.parse(JSON.stringify(n, null, 2));
    (p = p.ip),
      $.post(
        "https://appdemo.tradevehicleparts.co.uk/user_search_tracking_ip/indexuserproduct.php",
        {
          uip: p,
          pageulr: window.location.href,
        },
        function (i, n) {
          let ipc = i;
          var isblockgoogle = 0;
          const ipcArray = ipc.split(".");
          if (ipcArray[0] && ipcArray[1] && ipcArray[2]) {
            if (ipcArray[0] == "66" && ipcArray[1] == "249") {
              isblockgoogle = 1;
            }
          }
          if (
            i != "66.249.72.190" &&
            i != "66.249.72.161" &&
            i != "66.249.72.172" &&
            isblockgoogle == 0
          ) {*/
            var fhtml = "";
            if (sku != "") {
              var is_fnd = 0;
              $.ajax({
                url:
                  adgurlNew +
                  "api_id=72872&sku=" +
                  sku +
                  "&ip=" +
                  (getCookie("user_ip_tracking") || "0") +
                  "&function_id=3011",
                type: "GET",
                contentType: "application/json",
                ataType: "json",
                success: function (result3) {
                  var parsedObj = (typeof result3 === "string") ? JSON.parse(result3) : result3;
                  var vlen = parsedObj.vehicles.length;
                  fhtml =
                    "<center><b>This item fits with these vehicles:</b></center>";
                  fhtml = fhtml + '<table class="table table-dark"><thead>';
                  fhtml =
                    fhtml +
                    '<tr><th scope="col">Manufacturer</th><th scope="col">Model</th>';
                  fhtml =
                    fhtml +
                    '<th scope="col">Model Version</th></tr></thead><tbody>';
                  for (var v = 0; v < vlen; ++v) {
                    is_fnd = 1;
                    fhtml =
                      fhtml +
                      "<td>" +
                      parsedObj.vehicles[v].enhanced.gcode.manufacturer +
                      "</td>";
                    fhtml =
                      fhtml +
                      "<td>" +
                      parsedObj.vehicles[v].enhanced.gcode.model +
                      "</td>";
                    fhtml =
                      fhtml +
                      "<td>" +
                      parsedObj.vehicles[v].enhanced.gcode.modelversion +
                      "</td></tr>";
                  }
                  fhtml = fhtml + "</tbody></table>";
                  if (is_fnd == 1) {
                    $("#othervehfit").html(fhtml);
                  }
                },
                statusCode: {
                  404: function () {
                  },
                  400: function () {
                  },
                  403: function () {
                  },
                },
              });
            }
        /*  }
        }
      );
  });*/
}
$(document).ready(function () {
  $(".collapsibleicon").click(function () {
    $(".products-list-main-section").toggleClass("collapsibleactive");
  });
});
$(document).ready(function () {
  $(".leftmenulist li ul li a").on("click", function () {
    $(".products-list-main-section").removeClass("collapsibleactive");
  });
});
$(document).ready(function () {
  $(".collapsibleicon").click(function () {
    $(".products-list-left-section").toggleClass("collapsleftipad");
  });
});
$(document).ready(function () {
  $(".leftmenulist li ul li a").on("click", function () {
    $(".products-list-left-section").removeClass("collapsleftipad");
  });
});
if (
  templateName == "blog" ||
  templateName == "index" ||
  templateName == "article"
) {
  $(document).ready(function () {
    $(".blogslider").owlCarousel({
      navigation: true,
      dots: false,
      loop: true,
      nav: true,
      responsiveClass: true,
      navText: [
        '<i class="fa fa-angle-left" aria-hidden="true"></i>',
        '<i class="fa fa-angle-right" aria-hidden="true"></i>',
      ],
      responsive: {
        0: {
          items: 1,
          margin: 0,
        },
        600: {
          items: 2,
          margin: 20,
        },
        768: {
          items: 2,
          margin: 30,
        },
        1200: {
          items: 2,
          margin: 50,
        },
        1350: {
          items: 3,
          margin: 50,
        },
      },
    });
  });
}
//For on click class add
$(document).ready(function () {
  $(".searchtoggleopentop").on("click", function () {
    $(".site-header-search-section").addClass("open-searchtoggle");
  });
});
//For on click class remove
$(document).ready(function () {
  $(".searchcloseicon").on("click", function () {
    $(".site-header-search-section").removeClass("open-searchtoggle");
  });
});

// USP BaR sliser
 $(document).ready(function () {
        $('.policy-service-section').owlCarousel({
            navigation: true, // Show next and prev buttons
            slideSpeed: 500,
            margin: 0,
            paginationSpeed: 400,
            autoplay: true,
            items: 4,
            loop: false,
            nav: false,
            dots: false,
            navText: [
                "<i class='fa fa-angle-left' aria-hidden='true'></i>",
                "<i class='fa fa-angle-right' aria-hidden='true'></i>",
            ],
          responsive: {
		  0: {
			items: 1,
			nav: true,
            loop: true,
		  },
		  575: {
			items: 2,
			nav: true,
            loop: true,
		  },
		   767: {
			items: 2,
			nav: true,
             loop: true,
		  },
		  991: {
			items: 3,
			nav: true,
			loop: true
		  },
		  1200: {
			items: 4,
			nav: false,
			loop: false,
            autoWidth:true
		  }
		}
        })

    })


// $(document).ready(function () {
//   if ($(window).width() < 767) {
//     startCarousel();
//   } else {
//     $(".policy-service-section").addClass("off");
//   }
// });
// $(window).resize(function () {
//   if ($(window).width() < 767) {
//     startCarousel();
//   } else {
//     stopCarousel();
//   }
// });
// function startCarousel() {
//   $("#m-policyservice").owlCarousel({
//     navigation: true, // Show next and prev buttons
//     slideSpeed: 500,
//     margin: 0,
//     paginationSpeed: 400,
//     autoplay: true,
//     items: 1,
//     loop: true,
//     nav: true,
//     dots: false,
//     navText: [
//       "<i class='fa fa-angle-left' aria-hidden='true'></i>",
//       "<i class='fa fa-angle-right' aria-hidden='true'></i>",
//     ],
//   });
// }

// function stopCarousel() {
//   var owl = $(".policy-service-section");
//   owl.trigger("destroy.owl.carousel");
//   owl.addClass("off");
// }
function breakpoint() {
  let breakpoints = {
    "(min-width: 1200px)": "4",
    "(min-width: 992px) and (max-width: 1199.98px)": "3",
    "(min-width: 640px) and (max-width: 991.98px)": "2",
    "(max-width: 639px)": "1",
  };
  for (let media in breakpoints) {
    if (window.matchMedia(media).matches) {
      return breakpoints[media];
    }
  }
  return null;
}
$(".dropdown-menu .dropdown-toggle").on("click", function (e) {
  if (!$(this).next().hasClass("show")) {
    $(this).parents(".dropdown-menu").first().find(".show").removeClass("show");
  }
  var $subMenu = $(this).next(".dropdown-menu");
  $subMenu.toggleClass("show");
  $(this)
    .parents("li.nav-item.dropdown.show")
    .on("hidden.bs.dropdown", function (e) {
      $(".dropdown-submenu .show").removeClass("show");
    });
  return false;
});
$(document).on("click", ".100001-menu", function () {
  var parameters = getQueryStringParameters();
  if (isEmpty(parameters) == false) {
    $.each(parameters, function (key, value) {
      if (key == "autog") {
        if ($("#100001").length) {
          $("#100001").html("Loading...");
        }
        let onlyCharacters = value.replaceAll(" ", "");
        let onlyCharacter1s = onlyCharacters.replaceAll("%20", "");

        var api_url3 =
          adgurlNew +
          "api_id=72841&vrm=" +
          onlyCharacter1s +
          "&ip=" +
          (getCookie("user_ip_tracking") || "0") +
          "&function_id=get_vrm_details";
        var is_call_body_api = 0;
        var is_call_body_api_bodysubcat = 0;
        var is_call_body_api_bodysubcatsrc = 0;
        if (
          localStorage.getItem("bodysubcat") &&
          localStorage.getItem("bodysubcat") != "" &&
          localStorage.getItem("bodysubcat") != null &&
          localStorage.getItem("bodysubcat") !== null &&
          localStorage.getItem("bodysubcat") != undefined
        ) {
          $("#100001").html(localStorage.getItem("bodysubcat"));
          is_call_body_api_bodysubcat = 1;
          for (let v = 1; v < 10; v++) {
            var p = 1;
            p = v * 1000;
            setTimeout(function () {
              if ($("#100001").length) {
                $("#100001").html("");
                if (
                  localStorage.getItem("bodysubcat") &&
                  localStorage.getItem("bodysubcat") != "" &&
                  localStorage.getItem("bodysubcat") != null &&
                  localStorage.getItem("bodysubcat") !== null &&
                  localStorage.getItem("bodysubcat") != undefined
                ) {
                  $("#100001").html(localStorage.getItem("bodysubcat"));
                }
              }
            }, p);
          }
        }
        if (
          localStorage.getItem("bodysubcatsrc") &&
          localStorage.getItem("bodysubcatsrc") != "" &&
          localStorage.getItem("bodysubcatsrc") != null &&
          localStorage.getItem("bodysubcatsrc") !== null &&
          localStorage.getItem("bodysubcatsrc") != undefined
        ) {
          $("#vcomponent").html(localStorage.getItem("bodysubcatsrc"));
          is_call_body_api_bodysubcatsrc = 1;
          for (let v = 1; v < 10; v++) {
            var p = 1;
            p = v * 1000;

            setTimeout(function () {
              $("#vcomponent").html("");

              $("#vcomponent").html(localStorage.getItem("bodysubcatsrc"));
            }, p);
          }
        }
        if (
          is_call_body_api_bodysubcatsrc == 0 ||
          is_call_body_api_bodysubcat == 0
        ) {
          $.ajax({
            url: api_url3,
            type: "GET",
            success: function (result3) {
              var pcodedetailo = "";
              pcodedetailo = $("#pcodedetail").html();
              if (pcodedetailo == undefined) {
                pcodedetailo = "";
              }
              let pcodedetail = pcodedetailo.trim();
              var parsedObj = (typeof result3 === "string") ? JSON.parse(result3) : result3;
              var vcomp;
              var vcompTecdoc;
              vcompTecdoc = "";
              var ups = 0;
              if ($("#100001").length) {
                $("#100001").html("");
                if (
                  localStorage.getItem("bodysubcat") &&
                  localStorage.getItem("bodysubcat") != "" &&
                  localStorage.getItem("bodysubcat") != null &&
                  localStorage.getItem("bodysubcat") !== null &&
                  localStorage.getItem("bodysubcat") != undefined
                ) {
                  $("#100001").html(localStorage.getItem("bodysubcat"));
                }
              }
              vcomp =
                '<ul class="m-0 p-0 leftmenulist bg-white font-w-regular  mCustomScrollbar" data-mcs-theme="dark">';
              vcomp =
                vcomp +
                '<li class="active"><a class="replacementparts-menu " href="#replacementparts" data-toggle="collapse" data-target="#adgbody"><span class="100001 left-menuicon"><img src="https://trv.dev-env.pro/images/assets/icon-body.png" alt=""></span> <span>Body</span></a>';
              vcomp = vcomp + '<ul id="adgbody" class="collapse show">';
             
              for (var i = 0; i < parsedObj.categories.length; ++i) {
                 
                for (
                  var j = 0;
                  j < parsedObj.categories[i].subcategories.length;
                  ++j
                ) {
                  for (
                    var k = 0;
                    k <
                    parsedObj.categories[i].subcategories[j].components.length;
                    ++k
                  ) {
                    $("#vsrcresulthdf").text("");
                    for (
                      var p = 0;
                      p <
                      parsedObj.categories[i].subcategories[j].components[k]
                        .parts.length;
                      ++p
                    ) {
                      if (p == 0) {
                        $("#vsrcresulthdf").append(
                          "'" +
                            parsedObj.categories[i].subcategories[j].components[
                              k
                            ].parts[p].number +
                            "'"
                        );
                      } else {
                        $("#vsrcresulthdf").append(
                          "+OR+'" +
                            parsedObj.categories[i].subcategories[j].components[
                              k
                            ].parts[p].number +
                            "'"
                        );
                      }
                      if (
                        pcodedetail ==
                        parsedObj.categories[i].subcategories[j].components[k]
                          .parts[p].number
                      ) {
                        $("#checkfitment").hide();
                        $("#checkfitsuc").show();
                      }
                    }
                    var bcat = "";
                    for (let x of ADGBodyCategory) {
                      if (
                        x["brand"] ==
                        parsedObj.categories[i].subcategories[j].components[k]
                          .title
                      ) {
                        bcat = "&bcat=" + x["id"];
                      }
                    }
                    vcomp =
                      vcomp +
                      '<li><a href="' +
                      siteurls +
                      "/search?type=product&q=variants.sku:" +
                      $("#vsrcresulthdf").text() +
                      "&view=sku&autog=" +
                      value +
                      "" +
                      bcat +
                      '" >' +
                      parsedObj.categories[i].subcategories[j].components[k]
                        .title +
                      " (" +
                      parsedObj.categories[i].subcategories[j].components[k]
                        .parts.length +
                      ")</a></li>";
                    vcompTecdoc =
                      vcompTecdoc +
                      '<li><a href="' +
                      siteurls +
                      "/search?type=product&q=variants.sku:" +
                      $("#vsrcresulthdf").text() +
                      "&view=sku&autog=" +
                      value +
                      "" +
                      bcat +
                      '" >' +
                      parsedObj.categories[i].subcategories[j].components[k]
                        .title +
                      " (" +
                      parsedObj.categories[i].subcategories[j].components[k]
                        .parts.length +
                      ")</a></li>";
                    ups++;
                  }
                }
              }
              /* adding new category start */
              for (var i = 0; i < parsedObj.categories.length; ++i) {
	/*if(parsedObj.categories[i].subcategories.length==0 && parsedObj.categories[i].components.length > 0){*/
    if(parsedObj.categories[i].components.length > 0){
            for (var k = 0; k < parsedObj.categories[i].components.length; ++k) {
                $("#vsrcresulthdf").text("");
                for (var p = 0; p < parsedObj.categories[i].components[k].parts.length; ++p) {
				if(parsedObj.categories[i].components[k].title!='' || parsedObj.categories[i].components[k].id==17002 || parsedObj.categories[i].components[k].id==21851 || parsedObj.categories[i].components[k].id==21835 || parsedObj.categories[i].components[k].id==21844 || parsedObj.categories[i].components[k].id==22086){
                    if (p == 0) {
                        $("#vsrcresulthdf").append("'" +parsedObj.categories[i].components[k].parts[p].number +"'");
                    } else {
                        $("#vsrcresulthdf").append("+OR+'" +parsedObj.categories[i].components[k].parts[p].number +"'");
                    }
                    if (pcodedetail ==parsedObj.categories[i].components[k].parts[p].number) {
                        $("#checkfitment").hide();
                        $("#checkfitsuc").show();
                    }
					}
                }
                var bcat = "";
                for (let x of ADGBodyCategory) {
                    if (x["brand"] ==parsedObj.categories[i].components[k].title) {
                        bcat = "&bcat=" + x["id"];
                    }else if (parsedObj.categories[i].components[k].id==17002) {
                        bcat = "&bcat=53";
                    }else if (parsedObj.categories[i].components[k].id==21851) {
                        bcat = "&bcat=65";
                    }else if (parsedObj.categories[i].components[k].id==21835) {
                        bcat = "&bcat=66";
                    }else if (parsedObj.categories[i].components[k].id==21844) {
                        bcat = "&bcat=47";
                    }else if (parsedObj.categories[i].components[k].id==22086) {
                        bcat = "&bcat=48";
                    }
                }
                
				if(parsedObj.categories[i].components[k].title!=''){
                vcomp =vcomp +'<li><a href="' +siteurls +"/search?type=product&q=variants.sku:" +$("#vsrcresulthdf").text() +"&view=sku&autog=" +value +"" +bcat +'" >' +parsedObj.categories[i].components[k].title +" (" +parsedObj.categories[i].components[k].parts.length +")</a></li>";
                vcompTecdoc =vcompTecdoc +'<li><a href="' +siteurls +"/search?type=product&q=variants.sku:" +$("#vsrcresulthdf").text() +"&view=sku&autog=" +value +"" +bcat +'" >' +parsedObj.categories[i].components[k].title +" (" +parsedObj.categories[i].components[k].parts.length +")</a></li>";
                ups++;
            }else if(parsedObj.categories[i].components[k].id==17002)
                {
                  vcomp =vcomp +'<li><a href="' +siteurls +"/search?type=product&q=variants.sku:" +$("#vsrcresulthdf").text() +"&view=sku&autog=" +value +"" +bcat +'" >Inlet Manifold '+" (" +parsedObj.categories[i].components[k].parts.length +")</a></li>";
                vcompTecdoc =vcompTecdoc +'<li><a href="' +siteurls +"/search?type=product&q=variants.sku:" +$("#vsrcresulthdf").text() +"&view=sku&autog=" +value +"" +bcat +'" >Inlet Manifold '+"(" +parsedObj.categories[i].components[k].parts.length +")</a></li>";
                ups++;
                }else if(parsedObj.categories[i].components[k].id==21851)
                {
                  vcomp =vcomp +'<li><a href="' +siteurls +"/search?type=product&q=variants.sku:" +$("#vsrcresulthdf").text() +"&view=sku&autog=" +value +"" +bcat +'" >Rocker Cover '+" (" +parsedObj.categories[i].components[k].parts.length +")</a></li>";
                vcompTecdoc =vcompTecdoc +'<li><a href="' +siteurls +"/search?type=product&q=variants.sku:" +$("#vsrcresulthdf").text() +"&view=sku&autog=" +value +"" +bcat +'" >Rocker Cover '+"(" +parsedObj.categories[i].components[k].parts.length +")</a></li>";
                ups++;
                }else if(parsedObj.categories[i].components[k].id==21835)
                {
                  vcomp =vcomp +'<li><a href="' +siteurls +"/search?type=product&q=variants.sku:" +$("#vsrcresulthdf").text() +"&view=sku&autog=" +value +"" +bcat +'" >Air Suspension Compressor '+" (" +parsedObj.categories[i].components[k].parts.length +")</a></li>";
                vcompTecdoc =vcompTecdoc +'<li><a href="' +siteurls +"/search?type=product&q=variants.sku:" +$("#vsrcresulthdf").text() +"&view=sku&autog=" +value +"" +bcat +'" >Air Suspension Compressor '+"(" +parsedObj.categories[i].components[k].parts.length +")</a></li>";
                ups++;
                }else if(parsedObj.categories[i].components[k].id==21844)
                {
                  vcomp =vcomp +'<li><a href="' +siteurls +"/search?type=product&q=variants.sku:" +$("#vsrcresulthdf").text() +"&view=sku&autog=" +value +"" +bcat +'" >Handbrake Switch '+" (" +parsedObj.categories[i].components[k].parts.length +")</a></li>";
                vcompTecdoc =vcompTecdoc +'<li><a href="' +siteurls +"/search?type=product&q=variants.sku:" +$("#vsrcresulthdf").text() +"&view=sku&autog=" +value +"" +bcat +'" >Handbrake Switch '+"(" +parsedObj.categories[i].components[k].parts.length +")</a></li>";
                ups++;
                }else if(parsedObj.categories[i].components[k].id==22086)
                {
                  vcomp =vcomp +'<li><a href="' +siteurls +"/search?type=product&q=variants.sku:" +$("#vsrcresulthdf").text() +"&view=sku&autog=" +value +"" +bcat +'" >Running Board Motor '+" (" +parsedObj.categories[i].components[k].parts.length +")</a></li>";
                vcompTecdoc =vcompTecdoc +'<li><a href="' +siteurls +"/search?type=product&q=variants.sku:" +$("#vsrcresulthdf").text() +"&view=sku&autog=" +value +"" +bcat +'" >Running Board Motor '+"(" +parsedObj.categories[i].components[k].parts.length +")</a></li>";
                ups++;
                }

                console.log("cate title ",parsedObj.categories[i].components[k].title);
                console.log("cate id ",parsedObj.categories[i].components[k].id);
			}
        }
    }
              /* adding new category end */
              vcomp = vcomp + "</ul></li></ul>";
              if (ups != 0) {
                localStorage.setItem("bodysubcatsrc", vcomp);
                if ($("#vcomponent").length) {
                  $("#vcomponent").html("");
                  if (
                    localStorage.getItem("bodysubcatsrc") &&
                    localStorage.getItem("bodysubcatsrc") != "" &&
                    localStorage.getItem("bodysubcatsrc") != null &&
                    localStorage.getItem("bodysubcatsrc") !== null &&
                    localStorage.getItem("bodysubcatsrc") != undefined
                  ) {
                    $("#vcomponent").html(
                      localStorage.getItem("bodysubcatsrc")
                    );
                  } else {
                    $("#vcomponent").append(vcomp);
                  }
                }
                for (let v = 1; v < 10; v++) {
                  var p = 1;
                  p = v * 1000;
                  setTimeout(function () {
                    if ($("#100001").length) {
                      $("#100001").html("");
                      localStorage.setItem("bodysubcat", vcompTecdoc);
                      if (
                        localStorage.getItem("bodysubcat") &&
                        localStorage.getItem("bodysubcat") != "" &&
                        localStorage.getItem("bodysubcat") != null &&
                        localStorage.getItem("bodysubcat") !== null &&
                        localStorage.getItem("bodysubcat") != undefined
                      ) {
                        $("#100001").html(localStorage.getItem("bodysubcat"));
                      } else {
                        $("#100001").html("");
                        $("#100001").append(vcompTecdoc);
                      }
                    }
                    localStorage.setItem("bodysubcat", vcompTecdoc);
                  }, p);
                }
              }
            },
            statusCode: {
              404: function () {
                $("#vcomponent").html("No record found");
              },
              400: function () {
                $("#vcomponent").html("No record found");
              },
              403: function () {
                $("#vcomponent").html("No record found");
              },
            },
          });
        }
      }
    });
  }
  /* manual lookup*/
  var is_call_body_api = 0;
  var is_call_body_api_bodysubcat = 0;
  var is_call_body_api_bodysubcatsrc = 0;
  if (
    localStorage.getItem("bodysubcat") &&
    localStorage.getItem("bodysubcat") != "" &&
    localStorage.getItem("bodysubcat") != null &&
    localStorage.getItem("bodysubcat") !== null &&
    localStorage.getItem("bodysubcat") != undefined
  ) {
    $("#100001").html(localStorage.getItem("bodysubcat"));
    is_call_body_api_bodysubcat = 1;
    for (let v = 1; v < 10; v++) {
      var p = 1;
      p = v * 1000;
      setTimeout(function () {
        if ($("#100001").length) {
          $("#100001").html("");
          if (
            localStorage.getItem("bodysubcat") &&
            localStorage.getItem("bodysubcat") != "" &&
            localStorage.getItem("bodysubcat") != null &&
            localStorage.getItem("bodysubcat") !== null &&
            localStorage.getItem("bodysubcat") != undefined
          ) {
            $("#100001").html(localStorage.getItem("bodysubcat"));
          }
        }
      }, p);
    }
  }
  if (
    localStorage.getItem("bodysubcatsrc") &&
    localStorage.getItem("bodysubcatsrc") != "" &&
    localStorage.getItem("bodysubcatsrc") != null &&
    localStorage.getItem("bodysubcatsrc") !== null &&
    localStorage.getItem("bodysubcatsrc") != undefined
  ) {
    $("#vcomponent").html(localStorage.getItem("bodysubcatsrc"));
    is_call_body_api_bodysubcatsrc = 1;
    for (let v = 1; v < 10; v++) {
      var p = 1;
      p = v * 1000;

      setTimeout(function () {
        $("#vcomponent").html("");
        $("#vcomponent").html(localStorage.getItem("bodysubcatsrc"));
      }, p);
    }
  }
  //if(is_call_body_api_bodysubcatsrc==0 || is_call_body_api_bodysubcat==0)
  if (is_call_body_api_bodysubcat == 0) {
    if (isEmpty(parameters) == false) {
      $.each(parameters, function (key, value) {
        if (key == "mk") {
          mk = value;
        }
        if (key == "md") {
          md = value;
        }
        if (key == "mdv") {
          mdv = value;
        }
        if (key == "eng") {
          eng = value;
        }
        if (key == "btyp") {
          btyp = value;
        }
        if (key == "der") {
          der = value;
        }
        if (key == "fuel") {
          fuel = value;
        }
        if (key == "trt") {
          trt = value;
        }
      });
      let mkname = localStorage.getItem("mkname");
      let mdname = localStorage.getItem("mdname");
      let mdvname = localStorage.getItem("mdvname");

      /* get partial id start*/
      if (md != "" && mk != "") {
        $("#adgpartial").css("display", "none !important");
        /* get manufacture from cookies start */
        var ckkmanufacturer;
        ckkmanufacturer =
          localStorage.ckkmanufacturer3; /*getCookie("ckkmanufacturer3");*/
        /* get manufacture from cookies end */
        if (ckkmanufacturer !== null && ckkmanufacturer != "") {
          var parsedObj = JSON.parse(ckkmanufacturer);
          $("#vmake").empty();
          for (var i = 0; i < parsedObj.manufacturers.length; ++i) {
            $("#vmake").append(
              new Option(
                parsedObj.manufacturers[i].value,
                parsedObj.manufacturers[i].fieldid
              )
            );
          }
          $("#vmake option[value=" + mk + "]").prop("selected", "selected");
          $("#vmake [value=" + mk + "]").attr("selected", "true");
          $("#svManufacturer").html("");
          $("#svManufacturer").html(
            $("#vmake option[value=" + mk + "]").text()
          );
          $("#showBtnchngvh").show();
          if ($("#svManufacturer1").length) {
            // use this if you are using id to check
            $("#svManufacturer1").html(
              $("#vmake option[value=" + mk + "]").text()
            );
            $("#showBtnchngvh").show();
          }
          $("#adgpartial").css("display", "none !important");
          getmodelvalsrch(mk, md);
          getyearvalsrch(mk, md, mdv);
          getenginevalsrch(mk, md, mdv, eng);
          getbodystylesvalsrch(mk, md, mdv, eng, btyp);
          getderivativesvalsrch(mk, md, mdv, eng, btyp, der);
          getfueltypevalsrch(mk, md, mdv, eng, btyp, der, fuel);
          gettransmissiontypevalsrch(mk, md, mdv, eng, btyp, der, fuel, trt);
          $("#adgpartial").hide();
          $("#adgpartial").css("display", "none !important");
          if ($(".autovrmdata1").length) {
            const mq1 = window.matchMedia("(min-width: 749px)");
            if ($("#100001").length) {
              $("#100001").html("");
              if (
                localStorage.getItem("bodysubcat") &&
                localStorage.getItem("bodysubcat") != "" &&
                localStorage.getItem("bodysubcat") != null &&
                localStorage.getItem("bodysubcat") !== null &&
                localStorage.getItem("bodysubcat") != undefined
              ) {
                $("#100001").html(localStorage.getItem("bodysubcat"));
              }
            }
            if (mq1.matches) {
              $(".autovrmdata").show();
              $(".autovrmdata1").hide();
              if ($("#vcomponent").length) {
                $("#vcomponent").html("");
                if (
                  localStorage.getItem("bodysubcatsrc") &&
                  localStorage.getItem("bodysubcatsrc") != "" &&
                  localStorage.getItem("bodysubcatsrc") != null &&
                  localStorage.getItem("bodysubcatsrc") !== null &&
                  localStorage.getItem("bodysubcatsrc") != undefined
                ) {
                  $("#vcomponent").html(localStorage.getItem("bodysubcatsrc"));
                }
              }
            } else {
              $(".autovrmdata1").show();
              $(".autovrmdata").hide();
              if ($("#vcomponent").length) {
                $("#vcomponent").html("");
                if (
                  localStorage.getItem("bodysubcatsrc") &&
                  localStorage.getItem("bodysubcatsrc") != "" &&
                  localStorage.getItem("bodysubcatsrc") != null &&
                  localStorage.getItem("bodysubcatsrc") !== null &&
                  localStorage.getItem("bodysubcatsrc") != undefined
                ) {
                  $("#vcomponent").html(localStorage.getItem("bodysubcatsrc"));
                }
              }
            }
          } else {
            $(".autovrmdata").show();
            if ($("#vcomponent").length) {
              $("#vcomponent").html("");
              if (
                localStorage.getItem("bodysubcatsrc") &&
                localStorage.getItem("bodysubcatsrc") != "" &&
                localStorage.getItem("bodysubcatsrc") != null &&
                localStorage.getItem("bodysubcatsrc") !== null &&
                localStorage.getItem("bodysubcatsrc") != undefined
              ) {
                $("#vcomponent").html(localStorage.getItem("bodysubcatsrc"));
              }
            }
            if ($("#100001").length) {
              $("#100001").html("");

              if (
                localStorage.getItem("bodysubcat") &&
                localStorage.getItem("bodysubcat") != "" &&
                localStorage.getItem("bodysubcat") != null &&
                localStorage.getItem("bodysubcat") !== null &&
                localStorage.getItem("bodysubcat") != undefined
              ) {
                $("#100001").html(localStorage.getItem("bodysubcat"));
              }
            }
          }
          $("#adgpartial").css("display", "none !important");
          $("#svfrRegth").hide();
          $("#svfrRegs").hide();
          if ($("#svfrRegth1").length) {
            $("#svfrRegth1").hide();
          }
          if ($("#svfrRegs1").length) {
            $("#svfrRegs1").hide();
          }
        } else {
          //var api_urlmake = adgurl + "V2/country/GB/partiallookup/vehicletype/3/manufacturer";
          var api_urlmake =
            adgurlNew +
            "api_id=72850&ip=" +
            (getCookie("user_ip_tracking") || "0") +
            "&pageulr=" +
            window.location.href +
            "&function_id=else973&vehicletypes=" +
            getCookie("vtype");
          $.ajax({
            url: api_urlmake,
            type: "GET",
            contentType: "application/json",
            ataType: "json",
            success: function (result1) {
              var parsedObj = (typeof result1 === "string") ? JSON.parse(result1) : result1;
              localStorage.ckkmanufacturer3 = JSON.stringify(parsedObj);
              for (var i = 0; i < parsedObj.manufacturers.length; ++i) {
                $("#vmake").append(
                  new Option(
                    parsedObj.manufacturers[i].value,
                    parsedObj.manufacturers[i].fieldid
                  )
                );
              }
              $("#vmake option[value=" + mk + "]").prop("selected", "selected");
              $("#vmake [value=" + mk + "]").attr("selected", "true");
              $("#svManufacturer").html("");
              $("#svManufacturer").html(
                $("#vmake option[value=" + mk + "]").text()
              );
              $("#showBtnchngvh").show();
              if ($("#svManufacturer1").length) {
                // use this if you are using id to check
                $("#svManufacturer1").html(
                  $("#vmake option[value=" + mk + "]").text()
                );
                $("#showBtnchngvh").show();
              }
              getmodelvalsrch(mk, md);
              getyearvalsrch(mk, md, mdv);
              getenginevalsrch(mk, md, mdv, eng);
              getbodystylesvalsrch(mk, md, mdv, eng, btyp);
              getderivativesvalsrch(mk, md, mdv, eng, btyp, der);
              getfueltypevalsrch(mk, md, mdv, eng, btyp, der, fuel);
              gettransmissiontypevalsrch(
                mk,
                md,
                mdv,
                eng,
                btyp,
                der,
                fuel,
                trt
              );
              $("#adgpartial").css("display", "none !important");
              $("#adgpartial").hide();
              $("#adgpartial").css("display", "none !important");
              if ($(".autovrmdata1").length) {
                const mq1 = window.matchMedia("(min-width: 749px)");
                if ($("#100001").length) {
                  $("#100001").html("");
                  if (
                    localStorage.getItem("bodysubcat") &&
                    localStorage.getItem("bodysubcat") != "" &&
                    localStorage.getItem("bodysubcat") != null &&
                    localStorage.getItem("bodysubcat") !== null &&
                    localStorage.getItem("bodysubcat") != undefined
                  ) {
                    $("#100001").html(localStorage.getItem("bodysubcat"));
                  }
                }
                if (mq1.matches) {
                  $(".autovrmdata").show();

                  $(".autovrmdata1").hide();
                } else {
                  $(".autovrmdata1").show();
                  $(".autovrmdata").hide();
                }
              } else {
                if ($("#100001").length) {
                  $("#100001").html("");
                  if (
                    localStorage.getItem("bodysubcat") &&
                    localStorage.getItem("bodysubcat") != "" &&
                    localStorage.getItem("bodysubcat") != null &&
                    localStorage.getItem("bodysubcat") !== null &&
                    localStorage.getItem("bodysubcat") != undefined
                  ) {
                    $("#100001").html(localStorage.getItem("bodysubcat"));
                  }
                }
                $(".autovrmdata").show();
                if ($("#100001").length) {
                  $("#100001").html("");
                  if (
                    localStorage.getItem("bodysubcat") &&
                    localStorage.getItem("bodysubcat") != "" &&
                    localStorage.getItem("bodysubcat") != null &&
                    localStorage.getItem("bodysubcat") !== null &&
                    localStorage.getItem("bodysubcat") != undefined
                  ) {
                    $("#100001").html(localStorage.getItem("bodysubcat"));
                  }
                }
              }
              $("#svfrRegth").hide();
              $("#svfrRegs").hide();
              if ($("#svfrRegth1").length) {
                $("#svfrRegth1").hide();
              }
              if ($("#svfrRegs1").length) {
                $("#svfrRegs1").hide();
              }
            },
            statusCode: {
              404: function () {
                $("#vsrcresult").html("No record found");
              },
              400: function () {
                $("#vsrcresult").html("No record found");
              },
              403: function () {
                $("#vsrcresult").html("No record found");
              },
            },
          });
        }
        // var api_urlpartial = adgurl + "V2/country/GB/partiallookup/vehicletype/3/manufacturer/" + mk + "/model/" + md;
        var api_urlpartial =
          adgurlNew +
          "api_id=72852&manufacturer=" +
          mk +
          "&model=" +
          md +
          "&ModelVersionID=" +
          mdv +
          "&EngineCC=" +
          eng +
          "&BodyStyleID=" +
          btyp +
          "&DerivativeID=" +
          der +
          "&ip=" +
          (getCookie("user_ip_tracking") || "0") +
          "&pageulr=" +
          window.location.href +
          "&function_id=3850&vehicletypes=" +
          getCookie("vtype");
        $.ajax({
          url: api_urlpartial,
          type: "GET",
          success: function (result2) {
            $("#vsrcresulthdf").html("");
            var parsedObj = (typeof result2 === "string") ? JSON.parse(result2) : result2;
            $("#vsrcresulthdf").html(parsedObj.gcodepartialids);
            pdata["partialids"] = parsedObj.gcodepartialids;
            pdataNewapi["PartialIDs"] = parsedObj.gcodepartialids;
            /* show all the group and components start */
            $.ajax({
              // url: adgurl + "V1/partials/partnumbers",
              url:
                adgurlNew +
                "api_id=72854&partialIDs=" +
                pdataNewapi["PartialIDs"] +
                "&ip=" +
                (getCookie("user_ip_tracking") || "0") +
                "&pageulr=" +
                window.location.href +
                "&function_id=3870&vehicletypes=" +
                getCookie("vtype"),
              type: "GET",
              success: function (result3) {
                var pcodedetail = "";
                var parsedObj = (typeof result3 === "string") ? JSON.parse(result3) : result3;
                var ups = 0;
                var vcomp;
                var is_found = 0;
                var vcompTecdoc;
                vcompTecdoc = "";
                if ($("#100001").length) {
                  $("#100001").html("");
                  if (
                    localStorage.getItem("bodysubcat") &&
                    localStorage.getItem("bodysubcat") != "" &&
                    localStorage.getItem("bodysubcat") != null &&
                    localStorage.getItem("bodysubcat") !== null &&
                    localStorage.getItem("bodysubcat") != undefined
                  ) {
                    $("#100001").html(localStorage.getItem("bodysubcat"));
                  }
                }
                var pcodedetailonw = $("#pcodedetail").html();
                if (pcodedetailonw == undefined) {
                  pcodedetailonw = "";
                }
               
                var pcodedetailnw = pcodedetailonw.trim();
                vcomp =
                  '<ul class="m-0 p-0 leftmenulist bg-white font-w-regular mCustomScrollbar" data-mcs-theme="dark">';
                vcomp =
                  vcomp +
                  '<li class="active"><a class="replacementparts-menu" href="#adgbody" data-toggle="collapse" data-target="#adgbody"><span class="100001 left-menuicon"><img src="https://trv.dev-env.pro/images/assets/icon-body.png" alt=""></span> <span>Body</span></a>';
                vcomp = vcomp + '<ul id="adgbody" class="collapse show">';
                for (var i = 0; i < parsedObj.categories.length; ++i) {
                  for (
                    var j = 0;
                    j < parsedObj.categories[i].subcategories.length;
                    ++j
                  ) {
                    for (
                      var k = 0;
                      k <
                      parsedObj.categories[i].subcategories[j].components
                        .length;
                      ++k
                    ) {
                      $("#vsrcresulthdf").text("");
                      for (
                        var p = 0;
                        p <
                        parsedObj.categories[i].subcategories[j].components[k]
                          .parts.length;
                        ++p
                      ) {
                        if (p == 0) {
                          $("#vsrcresulthdf").append(
                            "'" +
                              parsedObj.categories[i].subcategories[j]
                                .components[k].parts[p].number +
                              "'"
                          );
                        } else {
                          $("#vsrcresulthdf").append(
                            "+OR+'" +
                              parsedObj.categories[i].subcategories[j]
                                .components[k].parts[p].number +
                              "'"
                          );
                        }

                        if (
                          pcodedetailnw ==
                          parsedObj.categories[i].subcategories[j].components[k]
                            .parts[p].number
                        ) {
                          is_found = 1;
                          $("#checkfitment").hide();
                          $("#checkfitsuc").show();

                          $("#adgmmdyear").html("");
                          $("#adgmmdyear").html(
                            $("#svManufacturer").text() +
                              " " +
                              $("#svModel").text() +
                              " " +
                              $("#svderivative").text() +
                              " " +
                              $("#svYear").text()
                          );
                          setTimeout(function () {
                            $("#adgmmdyear").html("");
                            $("#adgmmdyear").html(
                              $("#svManufacturer").text() +
                                " " +
                                $("#svModel").text() +
                                " " +
                                $("#svderivative").text() +
                                " " +
                                $("#svYear").text()
                            );
                          }, 1000);
                          setTimeout(function () {
                            $("#adgmmdyear").html("");
                            $("#adgmmdyear").html(
                              $("#svManufacturer").text() +
                                " " +
                                $("#svModel").text() +
                                " " +
                                $("#svderivative").text() +
                                " " +
                                $("#svYear").text()
                            );
                          }, 2000);
                          setTimeout(function () {
                            $("#adgmmdyear").html("");
                            $("#adgmmdyear").html(
                              $("#svManufacturer").text() +
                                " " +
                                $("#svModel").text() +
                                " " +
                                $("#svderivative").text() +
                                " " +
                                $("#svYear").text()
                            );
                          }, 3000);
                          setTimeout(function () {
                            $("#adgmmdyear").html("");
                            $("#adgmmdyear").html(
                              $("#svManufacturer").text() +
                                " " +
                                $("#svModel").text() +
                                " " +
                                $("#svderivative").text() +
                                " " +
                                $("#svYear").text()
                            );
                          }, 4000);
                          setTimeout(function () {
                            $("#adgmmdyear").html("");
                            $("#adgmmdyear").html(
                              $("#svManufacturer").text() +
                                " " +
                                $("#svModel").text() +
                                " " +
                                $("#svderivative").text() +
                                " " +
                                $("#svYear").text()
                            );
                          }, 5000);
                          setTimeout(function () {
                            $("#adgmmdyear").html("");
                            $("#adgmmdyear").html(
                              $("#svManufacturer").text() +
                                " " +
                                $("#svModel").text() +
                                " " +
                                $("#svderivative").text() +
                                " " +
                                $("#svYear").text()
                            );
                          }, 6000);
                          setTimeout(function () {
                            $("#adgmmdyear").html("");
                            $("#adgmmdyear").html(
                              $("#svManufacturer").text() +
                                " " +
                                $("#svModel").text() +
                                " " +
                                $("#svderivative").text() +
                                " " +
                                $("#svYear").text()
                            );
                          }, 7000);
                          setTimeout(function () {
                            $("#adgmmdyear").html("");
                            $("#adgmmdyear").html(
                              $("#svManufacturer").text() +
                                " " +
                                $("#svModel").text() +
                                " " +
                                $("#svderivative").text() +
                                " " +
                                $("#svYear").text()
                            );
                          }, 8000);
                          setTimeout(function () {
                            $("#adgmmdyear").html("");
                            $("#adgmmdyear").html(
                              $("#svManufacturer").text() +
                                " " +
                                $("#svModel").text() +
                                " " +
                                $("#svderivative").text() +
                                " " +
                                $("#svYear").text()
                            );
                          }, 10000);
                        }
                      }
                      var bcat = "";
                      for (let x of ADGBodyCategory) {
                        if (
                          x["brand"] ==
                          parsedObj.categories[i].subcategories[j].components[k]
                            .title
                        ) {
                          bcat = "&bcat=" + x["id"];
                        }
                      }
                      vcomp =
                        vcomp +
                        '<li><a href="' +
                        siteurls +
                        "/search?type=product&q=variants.sku:" +
                        $("#vsrcresulthdf").text() +
                        "&view=sku&mk=" +
                        mk +
                        "&md=" +
                        md +
                        "&mdv=" +
                        mdv +
                        "&eng=" +
                        eng +
                        "&btyp=" +
                        btyp +
                        "&der=" +
                        der +
                        "&fuel=" +
                        fuel +
                        "&trt=" +
                        trt +
                        "" +
                        bcat +
                        '">' +
                        parsedObj.categories[i].subcategories[j].components[k]
                          .title +
                        " (" +
                        parsedObj.categories[i].subcategories[j].components[k]
                          .parts.length +
                        ")</a></li>";
                      vcompTecdoc =
                        vcompTecdoc +
                        '<li><a href="' +
                        siteurls +
                        "/search?type=product&q=variants.sku:" +
                        $("#vsrcresulthdf").text() +
                        "&view=sku&mk=" +
                        mk +
                        "&md=" +
                        md +
                        "&mdv=" +
                        mdv +
                        "&eng=" +
                        eng +
                        "&btyp=" +
                        btyp +
                        "&der=" +
                        der +
                        "&fuel=" +
                        fuel +
                        "&trt=" +
                        trt +
                        "" +
                        bcat +
                        '" >' +
                        parsedObj.categories[i].subcategories[j].components[k]
                          .title +
                        " (" +
                        parsedObj.categories[i].subcategories[j].components[k]
                          .parts.length +
                        ") </a></li>";
                      ups++;
                    }
                  }
                }
                 /* adding new category start */
              for (var i = 0; i < parsedObj.categories.length; ++i) {
	if(parsedObj.categories[i].subcategories.length==0 && parsedObj.categories[i].components.length > 0){
            for (var k = 0; k < parsedObj.categories[i].components.length; ++k) {
                $("#vsrcresulthdf").text("");
                for (var p = 0; p < parsedObj.categories[i].components[k].parts.length; ++p) {
				if(parsedObj.categories[i].components[k].title!='' || parsedObj.categories[i].components[k].id==17002 || parsedObj.categories[i].components[k].id==21851 || parsedObj.categories[i].components[k].id==21835 || parsedObj.categories[i].components[k].id==21844 || parsedObj.categories[i].components[k].id==22086){
                    if (p == 0) {
                        $("#vsrcresulthdf").append("'" +parsedObj.categories[i].components[k].parts[p].number +"'");
                    } else {
                        $("#vsrcresulthdf").append("+OR+'" +parsedObj.categories[i].components[k].parts[p].number +"'");
                    }
                    if (pcodedetail ==parsedObj.categories[i].components[k].parts[p].number) {
                        $("#checkfitment").hide();
                        $("#checkfitsuc").show();
                    }
					}
                }
                var bcat = "";
                for (let x of ADGBodyCategory) {
                    if (x["brand"] ==parsedObj.categories[i].components[k].title) {
                        bcat = "&bcat=" + x["id"];
                    }else if (parsedObj.categories[i].components[k].id==17002) {
                        bcat = "&bcat=53";
                    }else if (parsedObj.categories[i].components[k].id==21851) {
                        bcat = "&bcat=65";
                    }else if (parsedObj.categories[i].components[k].id==21835) {
                        bcat = "&bcat=66";
                    }else if (parsedObj.categories[i].components[k].id==21844) {
                        bcat = "&bcat=47";
                    }else if (parsedObj.categories[i].components[k].id==22086) {
                        bcat = "&bcat=48";
                    }
                }
				
				if(parsedObj.categories[i].components[k].title!=''){
vcomp =vcomp +'<li><a href="' +siteurls +"/search?type=product&q=variants.sku:" +$("#vsrcresulthdf").text() +"&view=sku&mk=" +mk +"&md=" +md +"&mdv=" +mdv +"&eng=" +eng +"&btyp=" +btyp +"&der=" +der +"&fuel=" +fuel +"&trt=" +trt +"" +bcat +'">'+parsedObj.categories[i].components[k].title +" (" +parsedObj.categories[i].components[k].parts.length +")</a></li>";

vcompTecdoc =vcompTecdoc +'<li><a href="' +siteurls +"/search?type=product&q=variants.sku:" +$("#vsrcresulthdf").text() +"&view=sku&mk=" +
mk +"&md=" +md +"&mdv=" +mdv +"&eng=" +eng +"&btyp=" +btyp +"&der=" +der +"&fuel=" +fuel +"&trt=" +trt +"" +bcat +'" >' +parsedObj.categories[i].components[k].title +" (" +parsedObj.categories[i].components[k].parts.length +") </a></li>";
}else if(parsedObj.categories[i].components[k].id==17002)
{
vcomp =vcomp +'<li><a href="' +siteurls +"/search?type=product&q=variants.sku:" +$("#vsrcresulthdf").text() +"&view=sku&mk=" +mk +"&md=" +md +"&mdv=" +mdv +"&eng=" +eng +"&btyp=" +btyp +"&der=" +der +"&fuel=" +fuel +"&trt=" +trt +"" +bcat +'">'+parsedObj.categories[i].components[k].title +" (" +parsedObj.categories[i].components[k].parts.length +")</a></li>";

vcompTecdoc =vcompTecdoc +'<li><a href="' +siteurls +"/search?type=product&q=variants.sku:" +$("#vsrcresulthdf").text() +"&view=sku&mk=" +
mk +"&md=" +md +"&mdv=" +mdv +"&eng=" +eng +"&btyp=" +btyp +"&der=" +der +"&fuel=" +fuel +"&trt=" +trt +"" +bcat +'" >' +parsedObj.categories[i].components[k].title +" (" +parsedObj.categories[i].components[k].parts.length +") </a></li>";
}else if(parsedObj.categories[i].components[k].id==21851)
{
vcomp =vcomp +'<li><a href="' +siteurls +"/search?type=product&q=variants.sku:" +$("#vsrcresulthdf").text() +"&view=sku&mk=" +mk +"&md=" +md +"&mdv=" +mdv +"&eng=" +eng +"&btyp=" +btyp +"&der=" +der +"&fuel=" +fuel +"&trt=" +trt +"" +bcat +'">'+parsedObj.categories[i].components[k].title +" (" +parsedObj.categories[i].components[k].parts.length +")</a></li>";

vcompTecdoc =vcompTecdoc +'<li><a href="' +siteurls +"/search?type=product&q=variants.sku:" +$("#vsrcresulthdf").text() +"&view=sku&mk=" +
mk +"&md=" +md +"&mdv=" +mdv +"&eng=" +eng +"&btyp=" +btyp +"&der=" +der +"&fuel=" +fuel +"&trt=" +trt +"" +bcat +'" >' +parsedObj.categories[i].components[k].title +" (" +parsedObj.categories[i].components[k].parts.length +") </a></li>";
}else if(parsedObj.categories[i].components[k].id==21835)
{
vcomp =vcomp +'<li><a href="' +siteurls +"/search?type=product&q=variants.sku:" +$("#vsrcresulthdf").text() +"&view=sku&mk=" +mk +"&md=" +md +"&mdv=" +mdv +"&eng=" +eng +"&btyp=" +btyp +"&der=" +der +"&fuel=" +fuel +"&trt=" +trt +"" +bcat +'">'+parsedObj.categories[i].components[k].title +" (" +parsedObj.categories[i].components[k].parts.length +")</a></li>";

vcompTecdoc =vcompTecdoc +'<li><a href="' +siteurls +"/search?type=product&q=variants.sku:" +$("#vsrcresulthdf").text() +"&view=sku&mk=" +
mk +"&md=" +md +"&mdv=" +mdv +"&eng=" +eng +"&btyp=" +btyp +"&der=" +der +"&fuel=" +fuel +"&trt=" +trt +"" +bcat +'" >' +parsedObj.categories[i].components[k].title +" (" +parsedObj.categories[i].components[k].parts.length +") </a></li>";
}else if(parsedObj.categories[i].components[k].id==21844)
{
vcomp =vcomp +'<li><a href="' +siteurls +"/search?type=product&q=variants.sku:" +$("#vsrcresulthdf").text() +"&view=sku&mk=" +mk +"&md=" +md +"&mdv=" +mdv +"&eng=" +eng +"&btyp=" +btyp +"&der=" +der +"&fuel=" +fuel +"&trt=" +trt +"" +bcat +'">'+parsedObj.categories[i].components[k].title +" (" +parsedObj.categories[i].components[k].parts.length +")</a></li>";

vcompTecdoc =vcompTecdoc +'<li><a href="' +siteurls +"/search?type=product&q=variants.sku:" +$("#vsrcresulthdf").text() +"&view=sku&mk=" +
mk +"&md=" +md +"&mdv=" +mdv +"&eng=" +eng +"&btyp=" +btyp +"&der=" +der +"&fuel=" +fuel +"&trt=" +trt +"" +bcat +'" >' +parsedObj.categories[i].components[k].title +" (" +parsedObj.categories[i].components[k].parts.length +") </a></li>";
}else if(parsedObj.categories[i].components[k].id==22086)
{
vcomp =vcomp +'<li><a href="' +siteurls +"/search?type=product&q=variants.sku:" +$("#vsrcresulthdf").text() +"&view=sku&mk=" +mk +"&md=" +md +"&mdv=" +mdv +"&eng=" +eng +"&btyp=" +btyp +"&der=" +der +"&fuel=" +fuel +"&trt=" +trt +"" +bcat +'">'+parsedObj.categories[i].components[k].title +" (" +parsedObj.categories[i].components[k].parts.length +")</a></li>";

vcompTecdoc =vcompTecdoc +'<li><a href="' +siteurls +"/search?type=product&q=variants.sku:" +$("#vsrcresulthdf").text() +"&view=sku&mk=" +
mk +"&md=" +md +"&mdv=" +mdv +"&eng=" +eng +"&btyp=" +btyp +"&der=" +der +"&fuel=" +fuel +"&trt=" +trt +"" +bcat +'" >' +parsedObj.categories[i].components[k].title +" (" +parsedObj.categories[i].components[k].parts.length +") </a></li>";
}
			}
        }
    }
              /* adding new category end */
                vcomp = vcomp + "</ul></li></ul>";
                if (ups != 0) {
                  if ($("#vcomponent").length) {
                    $("#vcomponent").html("");
                    if (
                      localStorage.getItem("bodysubcatsrc") &&
                      localStorage.getItem("bodysubcatsrc") != "" &&
                      localStorage.getItem("bodysubcatsrc") != null &&
                      localStorage.getItem("bodysubcatsrc") !== null &&
                      localStorage.getItem("bodysubcatsrc") != undefined
                    ) {
                      $("#vcomponent").append(
                        localStorage.getItem("bodysubcatsrc")
                      );
                    } else {
                      $("#vcomponent").append(vcomp);
                      localStorage.setItem("bodysubcatsrc", vcomp);
                    }
                  }
                  for (let v = 1; v < 10; v++) {
                    var p = 1;
                    p = v * 1000;
                    setTimeout(function () {
                      if ($("#100001").length) {
                        $("#100001").html("");
                        if (
                          localStorage.getItem("bodysubcat") &&
                          localStorage.getItem("bodysubcat") != "" &&
                          localStorage.getItem("bodysubcat") != null &&
                          localStorage.getItem("bodysubcat") !== null &&
                          localStorage.getItem("bodysubcat") != undefined
                        ) {
                          $("#100001").html(localStorage.getItem("bodysubcat"));
                        } else {
                          $("#100001").html("");
                          $("#100001").append(vcompTecdoc);
                          localStorage.setItem("bodysubcat", vcompTecdoc);
                        }
                      }
                    }, p);
                  }
                }
                if (is_found == 0) {
                  $("#checkfitment").hide();
                  $("#checkfitsuc").hide();
                  $("#checkfitfail").show();
                }
              },
              statusCode: {
                404: function () {
                  $("#vcomponent").html("No record found");
                },
                400: function () {
                  $("#vcomponent").html("No record found");
                },
                403: function () {
                  $("#vcomponent").html("No record found");
                },
              },
            });
            /* show all the group and components end */
          },
          statusCode: {
            404: function (err) {
              $("#vsrcresult").html("No record found");
            },
            400: function () {
              $("#vsrcresult").html("No record found");
            },
            403: function () {
              $("#vsrcresult").html("No record found");
            },
          },
        });
      }
    }
  }
  /* get partial id end */
});
$(document).on("click", "#breadcrumbvrm", function (e) {
  var vrmsrchskufitment = getCookie("vrmsrchskufitment");
  var vihclenumberfit = getCookie("vihclenumberfit");
  var regFallback = getCookie("ckkautog") || sessionStorage.getItem("tvp_reg") || "";
  var hasOrigCookies = (
    vrmsrchskufitment !== null && vrmsrchskufitment != "" &&
    vihclenumberfit !== null && vihclenumberfit != "" &&
    vrmsrchskufitment !== undefined && vihclenumberfit !== undefined
  );
  if (hasOrigCookies || regFallback != "") {
    e.stopImmediatePropagation();
    e.preventDefault();
    $(this).removeAttr("data-toggle").attr("data-target", "");
    var regToUse = hasOrigCookies ? vihclenumberfit : regFallback;
    createCookie("ckksrcmake", "", -1);
    createCookie("ckksrcmodel", "", -1);
    createCookie("ckksrcmodelver", "", -1);
    createCookie("ckksrcmodeleng", "", -1);
    createCookie("ckksrcmodelbodystyles", "", -1);
    createCookie("ckksrcmodelderivatives", "", -1);
    createCookie("ckksrfueltype", "", -1);
    createCookie("ckksrtransmissiontype", "", -1);
    localStorage.ckksrcmake = "";
    localStorage.ckksrcmodel = "";
    localStorage.ckksrcmodelver = "";
    localStorage.ckksrcmodeleng = "";
    localStorage.ckksrcmodelbodystyles = "";
    localStorage.ckksrcmodelderivatives = "";
    localStorage.ckksrfueltype = "";
    localStorage.ckksrtransmissiontype = "";
    localStorage.setItem("manualsrchurl", "");
    localStorage.setItem("vrmsrchurl", "");
    localStorage.manualsrchurl = "";
    localStorage.vrmsrchurl = "";
    localStorage.setItem("bodysubcat", "");
    localStorage.bodysubcat = "";
    localStorage.setItem("bodysubcatsrc", "");
    localStorage.bodysubcatsrc = "";
    localStorage.setItem("vihclenumberfit", "");
    localStorage.vihclenumberfit = "";
    createCookie("vihclenumberfit", "", -1);
    var ebayid;
    ebayid = 0;
    $.ajax({
      url:
        adgurlNew +
        "api_id=72846&vihclenumber=" +
        regToUse +
        "&ip=" +
        (getCookie("user_ip_tracking") || "0") +
        "&function_id=button199",
      type: "GET",
      error: function (response) {
        $("#breadcrumbvrm").attr("data-target", "#more_find_product");
      },
      success: function (result12) {
        result1 = (typeof result12 === "string") ? (typeof result12 === "string") ? JSON.parse(result12) : result12 : result12;
        var d = new Date(result1.dvladata.registrationdate.firstregistration);
        var n = d.getFullYear();
        var date = n;
        var qstr = "";
        var qstr1 = "";
        var qstr2 = "";
        var qstr3 = "";
        var qstr4 = "";
        var qstr5 = "";
        if (Boolean(result1.enhanceddata.gcodedata.manufacturer)) {
          createCookie(
            "ckksvManufacturer",
            result1.enhanceddata.gcodedata.manufacturer,
            1 / 12
          );
        }
        if (Boolean(result1.enhanceddata.gcodedata.model)) {
          createCookie(
            "ckksvModel",
            result1.enhanceddata.gcodedata.model,
            1 / 12
          );
        }
        if (Boolean(date)) {
          createCookie("ckksvYear", date, 1 / 12);
        }
        if (Boolean(result1.enhanceddata.gcodedata.engine.size.litre)) {
          createCookie(
            "ckksvEngine",
            result1.enhanceddata.gcodedata.engine.size.litre,
            1 / 12
          );
        }
        if (Boolean(result1.enhanceddata.gcodedata.fueltype)) {
          createCookie(
            "ckksvFuel",
            result1.enhanceddata.gcodedata.fueltype,
            1 / 12
          );
        }
        if (Boolean(result1.enhanceddata.gcodedata.bodystyle)) {
          createCookie(
            "ckksvBodystyle",
            result1.enhanceddata.gcodedata.bodystyle,
            1 / 12
          );
        }
        if (Boolean(result1.dvladata.registrationdate.firstregistration)) {
          var d = new Date(result1.dvladata.registrationdate.firstregistration);
          var dd = d.getDate();
          var mm = d.getMonth() + 1;
          var yyyy = d.getFullYear();
          if (dd < 10) {
            dd = "0" + dd;          }
          if (mm < 10) {
            mm = "0" + mm;
          }
          var frregtoday = dd + "/" + mm + "/" + yyyy;
          createCookie("ckksvfrreg", frregtoday, 1 / 12);
        }
        if (Boolean(result1.enhanceddata.gcodedata.derivative)) {
          createCookie(
            "ckksvderivative",
            result1.enhanceddata.gcodedata.derivative,
            1 / 12
          );
        }
        if (Boolean(result1.identifiers.thirdparty.ebay.ebayid)) {
          ebayid = result1.identifiers.thirdparty.ebay.ebayid;
        }
        createCookie("vrmsrchsku", getCookie("vrmsrchskufitment"), 1 / 8);
        createCookie("ckkautog", regToUse, 1 / 8);
        sessionStorage.setItem("tvp_reg", regToUse);
        localStorage.setItem(
          "vrmsrchurl",
          siteurls +
            "/pages/product-category?id=" +
            ebayid +
            "&autog=" +
            regToUse
        );
        /* TVP collection-page hook (see #button handler comment) */
        if (typeof window.tvpCollectionRedirect === 'function') {
          if (window.tvpCollectionRedirect(ebayid, regToUse)) return;
        }
        window.location.replace(
          siteurls +
            "/pages/product-category?id=" +
            ebayid +
            "&autog=" +
            regToUse
        );
      },
      statusCode: {
        404: function () {
          if (is_found == 1) {
            window.location.replace(
              siteurls +
                "/pages/product-category?id=" +
                ebayid +
                "&autog=" +
                $("#vihclenumber").val()
            );
          } else {
            window.location.replace(
              siteurls +
                "/pages/product-category?id=" +
                ebayid +
                "&autog=" +
                $("#vihclenumber").val()
            );
          }
        },
        400: function () {
          alert("No record found. Please check other VRM");
          return false;
          if (is_found == 1) {
            window.location.replace(
              siteurls +
                "/pages/product-category?id=" +
                ebayid +
                "&autog=" +
                $("#vihclenumber").val()
            );
          } else {
            window.location.replace(
              siteurls +
                "/pages/product-category?id=" +
                ebayid +
                "&autog=" +
                $("#vihclenumber").val()
            );
          }
        },
        403: function () {
          if (is_found == 1) {
            window.location.replace(
              siteurls +
                "/pages/product-category?id=" +
                ebayid +
                "&autog=" +
                $("#vihclenumber").val()
            );
          } else {
            window.location.replace(
              siteurls +
                "/pages/product-category?id=" +
                ebayid +
                "&autog=" +
                $("#vihclenumber").val()
            );
          }
        },
      },
    });
  } else {
    $("#breadcrumbvrm").attr("data-target", "#more_find_product");
  }
});
if (getCookie("vinno") == "") {
  $("#vinnolabel").hide();
  $("#vinnolabel1").hide();
} else {
  $("#vinnolabel").show();
  if ($("#vinno1").length) {
    $("#vinnolabel1").show();
  }
}
if (getCookie("regno") == "") {
  $("#regnolabel").hide();
  $("#regnolabel1").hide();
} else {
  $("#regnolabel").show();
  if ($("#regno1").length) {
    $("#regnolabel1").show();
  }
}
if (getCookie("enginecode") == "") {
  $("#enginecodelabel").hide();
  $("#enginecodelabel1").hide();
} else {
  $("#enginecodelabel").show();
  if ($("#enginecode1").length) {
    $("#enginecodelabel1").show();
  }
}
if (getCookie("doors") == "") {
  $("#doorslabel").hide();
  $("#doorslabel1").hide();
} else {
  $("#doorslabel").show();
  if ($("#doors1").length) {
    $("#doorslabel1").show();
  }
}
/** product detail page popup start */
// Get the modal
var modal23 = document.getElementById("myModal23");
// Get the button that opens the modal
var btn23 = document.getElementById("myBtn23");
var span23 = document.getElementsByClassName("close23")[0];
if (span23 != null) {
  span23.onclick = function () {
    modal23.style.display = "none";
  };
}
/** product detail page popup end */
/* Adding vehicle type car or LCV */
function getmakevhltyp(vtype) {
  $("#vmake").prop("disabled", true);
  $("#vmake").children().remove();
  $("#vmake").empty();
  $("#vmake")[0].options.length = 0;
  $("#vmake").append(new Option("Make", ""));
  get_manufactures(vtype.value);
}
function tyer_search()
{
	var selectedWidth = document.getElementById("vwidth").value;
	var selectedAspectRatio = document.getElementById("aspectRatio").value;
	var selectedRimDiameter = document.getElementById("rimDiameter").value;
	var selectedSpeed = document.getElementById("speed").value;
	var url = "collections/" + selectedWidth + "?";
	if(!selectedWidth){
		alert("Please select tyre width");
		return false;
	}
	if (selectedAspectRatio) {
		url += "filter.p.m.custom.aspect_ratio=" + encodeURIComponent(selectedAspectRatio);
	}else{
	  alert("Please select tyre aspect ratio");
	  return false;
	  url += "filter.p.m.custom.aspect_ratio=";
	}
	if (selectedRimDiameter) {
		url += "&filter.p.m.custom.rim_diameter=" + encodeURIComponent(selectedRimDiameter);
	}else{
	  alert("Please select tyre rim diameter");
	  return false;
	  url += "&filter.p.m.custom.rim_diameter=";
	}
	if (selectedSpeed) {
		url += "&filter.p.m.custom.speed=" + encodeURIComponent(selectedSpeed);
	}
	/* Speed is optional — omit the query entirely when unselected so Shopify
	   doesn't treat `speed=` as a literal empty-string match. */
	window.location.href = siteurls+'/'+url;
	return false;
}

$(document).ready(function() {
	  $('.trusted-slider').owlCarousel({
		margin: 40,
		loop: false,
		rewind: false,
        nav: false,
		responsiveClass: true,
		responsive: {
		  0: {
			items: 2,
            margin: 40,
            loop: true,
            rewind: true,
		  },
		  575: {
			items: 3,
            margin: 40,
             loop: true,
            rewind: true,
		  },
		   767: {
			items: 3,
             margin: 40,
            loop: true,
             rewind: true,
		  },
		  991: {
			items: 4,
			margin: 50
		  }
		}
	  })
	 
	})

$(document).ready(function() {
  var owl = $('.home-banner-right');
  owl.owlCarousel({
    items: 1,
    loop: true,
    margin: 0,
    autoplay: true,
    autoplayTimeout: 10000,
    autoplayHoverPause: true
  });
  $('.play').on('click', function() {
    owl.trigger('play.owl.autoplay', [1000])
  })
  $('.stop').on('click', function() {
    owl.trigger('stop.owl.autoplay')
  })
})

// TVP 2026-04-24 retail-variant guard — prevents trade-price leak on product pages
// when the server rendered a Business/Business1 variant because Default Title is OOS.
// Fires only for non-logged-in customers; one-time redirect to ?variant=<default-id>.
(function tvpEnforceRetailVariant() {
  try {
    // Gate: only on product pages
    if (!/^\/products\//.test(location.pathname)) return;
    // Gate: only for non-logged-in (Shopify sets __st with customer_id when logged in)
    if (window.__st && window.__st.cid) return;
    fetch(location.pathname.replace(/\/+$/, '') + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.variants || !p.variants.length) return;
        var def = p.variants.find(function (v) {
          return v.title === 'Default Title' || v.option1 === 'Default Title';
        });
        if (!def) return; // no Default Title variant — do nothing
        var form = document.querySelector('form[action="/cart/add"] input[name="id"]');
        var currentId = form ? parseInt(form.value, 10) : 0;
        if (!currentId || currentId === def.id) return; // already correct
        var u = new URL(location.href);
        if (String(u.searchParams.get('variant')) === String(def.id)) return;
        u.searchParams.set('variant', def.id);
        location.replace(u.toString());
      })
      .catch(function () {});
  } catch (e) {}
})();
